/**
 * My API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import { HttpClient, HttpResponse, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';

import { BucketComponentModificationResponse } from '@coin/shared/core/util-models-v2';
import { BucketComponentsPossibilities } from '@coin/shared/core/util-models-v2';
import { BudgetBucketModel } from '@coin/shared/core/util-models-v2';
import { BudgetBucketModificationResponse } from '@coin/shared/core/util-models-v2';
import { CalculateManySimulations } from '@coin/shared/core/util-models-v2';
import { CalculateSimulation } from '@coin/shared/core/util-models-v2';
import { CandidatePoolModel } from '@coin/shared/core/util-models-v2';
import { ChangeManyPriorities } from '@coin/shared/core/util-models-v2';
import { CreateBucketComponent } from '@coin/shared/core/util-models-v2';
import { CreateCandidatePool } from '@coin/shared/core/util-models-v2';
import { CreateEmployeeSnapshot } from '@coin/shared/core/util-models-v2';
import { CreateInformationVisibilitySettings } from '@coin/shared/core/util-models-v2';
import { CreateManyBucketComponents } from '@coin/shared/core/util-models-v2';
import { CreateMember } from '@coin/shared/core/util-models-v2';
import { CreateOrganisationInformationSnapshot } from '@coin/shared/core/util-models-v2';
import { CreatePlan } from '@coin/shared/core/util-models-v2';
import { CreatePlanSettings } from '@coin/shared/core/util-models-v2';
import { CreatePublicationSettings } from '@coin/shared/core/util-models-v2';
import { CreateSeason } from '@coin/shared/core/util-models-v2';
import { DuplicateSeason } from '@coin/shared/core/util-models-v2';
import { EmployeePopulationCreatedResultPagedDto } from '@coin/shared/core/util-models-v2';
import { EmployeeSeasonOverview } from '@coin/shared/core/util-models-v2';
import { EmployeeSnapshotsEmployeeSnapshot } from '@coin/shared/core/util-models-v2';
import { ExportEmployeePopulationResultDto } from '@coin/shared/core/util-models-v2';
import { Import } from '@coin/shared/core/util-models-v2';
import { LoadImport } from '@coin/shared/core/util-models-v2';
import { MemberModel } from '@coin/shared/core/util-models-v2';
import { MeritCommunicationSettings } from '@coin/shared/core/util-models-v2';
import { MeritInformationVisibilitySettingsModel } from '@coin/shared/core/util-models-v2';
import { OrganisationInformationSnapshotModel } from '@coin/shared/core/util-models-v2';
import { OrganisationSnapshotModel } from '@coin/shared/core/util-models-v2';
import { OrganisationSnapshotTreeItem } from '@coin/shared/core/util-models-v2';
import { PageOfEmployeeSnapshotsEmployeeSnapshot } from '@coin/shared/core/util-models-v2';
import { PageOfEmployeesEmployeesEmployee } from '@coin/shared/core/util-models-v2';
import { PageOfMember } from '@coin/shared/core/util-models-v2';
import { PageOfMeritInformationVisibilitySettings } from '@coin/shared/core/util-models-v2';
import { PageOfOrganisationInformationSnapshot } from '@coin/shared/core/util-models-v2';
import { PageOfOrganisationSnapshot } from '@coin/shared/core/util-models-v2';
import { PageOfPlan } from '@coin/shared/core/util-models-v2';
import { PageOfPlanWithMissingIndividualValues } from '@coin/shared/core/util-models-v2';
import { PageOfPositionEvaluationCandidate } from '@coin/shared/core/util-models-v2';
import { PageOfRecord } from '@coin/shared/core/util-models-v2';
import { PageOfSeason } from '@coin/shared/core/util-models-v2';
import { PageOfSnapshot } from '@coin/shared/core/util-models-v2';
import { PageOfString } from '@coin/shared/core/util-models-v2';
import { PlanModel } from '@coin/shared/core/util-models-v2';
import { PlanSettingsModel } from '@coin/shared/core/util-models-v2';
import { PopulationCreatedResultPagedDto } from '@coin/shared/core/util-models-v2';
import { PositionEvaluationSimulationModel } from '@coin/shared/core/util-models-v2';
import { PublicationSettingsModel } from '@coin/shared/core/util-models-v2';
import { RecordModel } from '@coin/shared/core/util-models-v2';
import { RuleSet } from '@coin/shared/core/util-models-v2';
import { SeasonModel } from '@coin/shared/core/util-models-v2';
import { SeasonSettingsModel } from '@coin/shared/core/util-models-v2';
import { SeasonsSimulationsCreateSimulation } from '@coin/shared/core/util-models-v2';
import { SeasonsSimulationsSimulation } from '@coin/shared/core/util-models-v2';
import { SeasonsSimulationsUpdateSimulation } from '@coin/shared/core/util-models-v2';
import { SetSeasonSettings } from '@coin/shared/core/util-models-v2';
import { SimulationPopulationCreated } from '@coin/shared/core/util-models-v2';
import { SimulationPublicationsPublishSimulation } from '@coin/shared/core/util-models-v2';
import { Snapshot } from '@coin/shared/core/util-models-v2';
import { StatusResponse } from '@coin/shared/core/util-models-v2';
import { TransactionStatusOfCalculationStatus } from '@coin/shared/core/util-models-v2';
import { TransactionStatusOfCandidatePoolRecalculationMetadata } from '@coin/shared/core/util-models-v2';
import { TransactionStatusOfExportStatusMetadata } from '@coin/shared/core/util-models-v2';
import { TransactionStatusOfIMetadata } from '@coin/shared/core/util-models-v2';
import { TransactionStatusOfImportStatusMetadata } from '@coin/shared/core/util-models-v2';
import { TransactionStatusOfMassSimulationCalculationMetadata } from '@coin/shared/core/util-models-v2';
import { TransactionStatusOfPlanPopulationCreationMetadata } from '@coin/shared/core/util-models-v2';
import { TransactionStatusOfPlanPopulationRecalculationMetadata } from '@coin/shared/core/util-models-v2';
import { TransactionStatusOfPopulationCreationMetadata } from '@coin/shared/core/util-models-v2';
import { TransactionStatusOfSettingsPopulationRecalculationMetadata } from '@coin/shared/core/util-models-v2';
import { TransactionStatusOfSimpleStatusMetadata } from '@coin/shared/core/util-models-v2';
import { TransactionStatusOfSimulationPublishMetadata } from '@coin/shared/core/util-models-v2';
import { UnPublishSimulation } from '@coin/shared/core/util-models-v2';
import { UpdateBucketComponent } from '@coin/shared/core/util-models-v2';
import { UpdateBudgetBucket } from '@coin/shared/core/util-models-v2';
import { UpdateCandidatePool } from '@coin/shared/core/util-models-v2';
import { UpdateCommunicationSettings } from '@coin/shared/core/util-models-v2';
import { UpdateEmployeeSnapshot } from '@coin/shared/core/util-models-v2';
import { UpdateEmployeeSnapshotPartial } from '@coin/shared/core/util-models-v2';
import { UpdateInformationVisibilitySettings } from '@coin/shared/core/util-models-v2';
import { UpdateManyBucketComponents } from '@coin/shared/core/util-models-v2';
import { UpdateManyBudgetBuckets } from '@coin/shared/core/util-models-v2';
import { UpdateMember } from '@coin/shared/core/util-models-v2';
import { UpdateOrganisationInformationSnapshot } from '@coin/shared/core/util-models-v2';
import { UpdatePlan } from '@coin/shared/core/util-models-v2';
import { UpdatePlanSettings } from '@coin/shared/core/util-models-v2';
import { UpdatePublicationSettings } from '@coin/shared/core/util-models-v2';
import { UpdateSeason } from '@coin/shared/core/util-models-v2';
import { UpdateSimulationMembers } from '@coin/shared/core/util-models-v2';
import { UpdateSnapshotBenchmarkValues } from '@coin/shared/core/util-models-v2';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';
import { BaseService, RequestArgs, RequestOptions } from '../api.base.service';

export interface ImportOrganisationSnapshotsParams {
  seasonId: string;
  loadImport?: LoadImport;
}

export interface SeasonsMeritAdminCalculateManySimulationParams {
  seasonId: string;
  calculateManySimulations?: CalculateManySimulations;
}

export interface SeasonsMeritAdminCalculateSimulationParams {
  seasonId: string;
  calculateSimulation?: CalculateSimulation;
}

export interface SeasonsMeritAdminChangePrioritiesInformationVisibilitySettingsParams {
  simulationId: string;
  changeManyPriorities?: ChangeManyPriorities;
}

export interface SeasonsMeritAdminChangePrioritiesPlansParams {
  changeManyPriorities?: ChangeManyPriorities;
}

export interface SeasonsMeritAdminCreateBudgetComponentsParams {
  budgetBucketId: string;
  createBucketComponent?: CreateBucketComponent;
}

export interface SeasonsMeritAdminCreateCandidatePoolsParams {
  createCandidatePool?: CreateCandidatePool;
}

export interface SeasonsMeritAdminCreateEmployeeSnapshotsParams {
  createEmployeeSnapshot?: CreateEmployeeSnapshot;
}

export interface SeasonsMeritAdminCreateInformationVisibilitySettingsParams {
  simulationId: string;
  createInformationVisibilitySettings?: CreateInformationVisibilitySettings;
}

export interface SeasonsMeritAdminCreateManyBudgetComponentsParams {
  budgetBucketId: string;
  createManyBucketComponents?: CreateManyBucketComponents;
}

export interface SeasonsMeritAdminCreateMembersParams {
  createMember?: CreateMember;
}

export interface SeasonsMeritAdminCreateOrganisationInformationSnapshotsParams {
  seasonId: string;
  createOrganisationInformationSnapshot?: CreateOrganisationInformationSnapshot;
}

export interface SeasonsMeritAdminCreatePlanSettingsParams {
  planId: string;
  createPlanSettings?: CreatePlanSettings;
}

export interface SeasonsMeritAdminCreatePlansParams {
  createPlan?: CreatePlan;
}

export interface SeasonsMeritAdminCreatePublicationSettingsParams {
  seasonId: string;
  createPublicationSettings?: CreatePublicationSettings;
}

export interface SeasonsMeritAdminCreateSeasonsParams {
  createSeason?: CreateSeason;
}

export interface SeasonsMeritAdminCreateSimulationParams {
  seasonsSimulationsCreateSimulation?: SeasonsSimulationsCreateSimulation;
}

export interface SeasonsMeritAdminDeleteBudgetComponentsParams {
  budgetBucketId: string;
}

export interface SeasonsMeritAdminDeleteCandidatePoolsParams {
  id: string;
}

export interface SeasonsMeritAdminDeleteEmployeeSnapshotsParams {
  snapshotId: string;
}

export interface SeasonsMeritAdminDeleteMembersParams {
  id: string;
}

export interface SeasonsMeritAdminDeleteOrganisationInformationSnapshotsParams {
  id: string;
  seasonId: string;
}

export interface SeasonsMeritAdminDeletePlanSettingsParams {
  id: string;
  planId: string;
}

export interface SeasonsMeritAdminDeletePlansParams {
  id: string;
}

export interface SeasonsMeritAdminDeleteSeasonsParams {
  id: string;
}

export interface SeasonsMeritAdminDeleteSimulationSettingsParams {
  id: string;
  seasonId: string;
  simulationId: string;
  settingsType?:
    | 'Merit'
    | 'Equity'
    | 'EquitySub'
    | 'Validation'
    | 'Placement'
    | 'ValidationHr'
    | 'PlacementHr'
    | 'Other'
    | 'NewHirePlan'
    | 'NewHireMerit'
    | 'NewHireEquity'
    | 'NewHireEquitySub'
    | 'IndividualMultiplier'
    | 'InformationVisibility'
    | 'Incentive'
    | 'NewHireIncentive'
    | 'IncentiveSub'
    | 'NewHireIncentiveSub';
}

export interface SeasonsMeritAdminDuplicateSeasonsParams {
  id: string;
  duplicateSeason?: DuplicateSeason;
}

export interface SeasonsMeritAdminExportEmployeeCandidatesParams {
  seasonId: string;
  queryGid?: string;
  queryFirstname?: string;
  queryLastname?: string;
  queryPAOrgCode?: Array<string>;
  queryCandidatePoolTitle?: Array<string>;
  queryOrgCode?: string;
  queryGender?: Array<'Male' | 'Female' | 'Undefined'>;
  queryOrgLevel?: Array<number>;
  queryMercerPositionClass?: Array<number>;
  queryIsPlaced?: boolean;
  queryIsShortlisted?: boolean;
  recordIds?: Array<string>;
  state?: 'Open' | 'Done';
  filename?: string;
}

export interface SeasonsMeritAdminExportOrganisationInformationSnapshotsParams {
  seasonId: string;
  orgCode?: Array<string>;
  orgName?: Array<string>;
  orgSize?: number;
  revenue?: number;
  headCount?: number;
  revenueOrgSize?: number;
  headCountOrgSize?: number;
  /** Export only: restricts the export to the organisations without organisation information or with a missing org size, like in the organisation list. Only the organisation filters (OrgCode, OrgName) apply then. */
  showOrganisationsWithoutOrgInfos?: boolean;
  fileName?: string;
}

export interface SeasonsMeritAdminExportOrganisationSnapshotsParams {
  seasonId: string;
}

export interface SeasonsMeritAdminExportPlanWithMissingIndividualValuesParams {
  seasonId?: string;
}

export interface SeasonsMeritAdminExportSeasonPopulationsParams {
  seasonId: string;
}

export interface SeasonsMeritAdminGetBudgetBucketsParams {
  id: string;
}

export interface SeasonsMeritAdminGetBudgetBucketsPlansParams {
  id: string;
}

export interface SeasonsMeritAdminGetByIdRecordsParams {
  /** id of the record entity */
  recordId: string;
}

export interface SeasonsMeritAdminGetEmployeeSnapshotsParams {
  snapshotId: string;
}

export interface SeasonsMeritAdminGetInformationFieldValuesOrganisationInformationSnapshotsParams {
  seasonId: string;
  targetProperty?: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7;
  orgCode?: Array<string>;
  page?: number;
  size?: number;
}

export interface SeasonsMeritAdminGetMembersParams {
  id: string;
}

export interface SeasonsMeritAdminGetMySeasonRecordsSeasonsParams {
  id: string;
  memberId?: string;
  gid?: string;
}

export interface SeasonsMeritAdminGetOfSeasonPublicationSettingsParams {
  seasonId: string;
}

export interface SeasonsMeritAdminGetOrganisationInformationSnapshotsParams {
  id: string;
  seasonId: string;
}

export interface SeasonsMeritAdminGetOrganisationSnapshotsParams {
  seasonId: string;
  id: string;
}

export interface SeasonsMeritAdminGetPlanPopulationPlansParams {
  id: string;
  page?: number;
  size?: number;
}

export interface SeasonsMeritAdminGetPlanRecordsPlansParams {
  id: string;
  page?: number;
  size?: number;
}

export interface SeasonsMeritAdminGetPlanSettingsParams {
  planId: string;
}

export interface SeasonsMeritAdminGetPlansParams {
  id: string;
}

export interface SeasonsMeritAdminGetPublicationSettingsParams {
  id: string;
  seasonId: string;
}

export interface SeasonsMeritAdminGetRecordsParams {
  /**  */
  seasonId: string;
  memberId?: string;
  gid?: Array<string>;
  firstName?: Array<string>;
  lastName?: Array<string>;
  country?: Array<string>;
  are?: Array<string>;
  orgCode?: Array<string>;
  state?: Array<string>;
  planName?: Array<string>;
  startDate?: string;
  endDate?: string;
  assignmentId?: string;
  isDesignReady?: boolean;
  letterState?: Array<string>;
  payoutState?: Array<string>;
  template?: string;
  workflow?: string;
  seasonId2?: string;
  workflowInstanceState?: Array<string>;
  lineManagerName?: string;
  lineManagerGid?: Array<string>;
  lineManagerPositionClass?: number;
  page?: number;
  size?: number;
  orderBy?: 'Asc' | 'Desc';
  property?: string;
}

export interface SeasonsMeritAdminGetSeasonCommunicationSettingsParams {
  seasonId: string;
}

export interface SeasonsMeritAdminGetSeasonOverviewForEmployeeMembersParams {
  gid?: string;
}

export interface SeasonsMeritAdminGetSeasonRecordsSeasonsParams {
  id: string;
  queryId?: Array<string>;
  queryGid?: Array<string>;
  queryFirstName?: Array<string>;
  queryLastName?: Array<string>;
  queryCountry?: Array<string>;
  queryAre?: Array<string>;
  queryOrgCode?: Array<string>;
  queryOrgClusterNodeName?: Array<string>;
  queryState?: Array<'Active' | 'Draft' | 'Outdated' | 'Irrelevant'>;
  queryPlanName?: Array<string>;
  queryStartDate?: string;
  queryEndDate?: string;
  queryAssignmentId?: string;
  queryLetterType?:
    | 'Other'
    | 'AdherenceLetter'
    | 'TargetAgreementForm'
    | 'TargetAchievementForm'
    | 'MeritAllocation'
    | 'SpecialRecognitionLetter'
    | 'RestructuringCalculation'
    | 'RestructuringLetter';
  queryTemplateType?: Array<
    | 'Other'
    | 'AdherenceLetter'
    | 'TargetAgreementForm'
    | 'TargetAchievementForm'
    | 'MeritAllocation'
    | 'SpecialRecognitionLetter'
    | 'RestructuringCalculation'
    | 'RestructuringLetter'
  >;
  queryProcessStates?: Array<
    | 'None'
    | 'Open'
    | 'TafCreated'
    | 'TafPublished'
    | 'ReadyForCalculation'
    | 'Calculated'
    | 'Frozen'
    | 'AchievementLetterCreated'
    | 'AchievementLetterPublished'
  >;
  queryRecordCommunicationStates?: Array<
    | 'None'
    | 'Created'
    | 'InManagerReview'
    | 'InEmployeeReview'
    | 'Published'
    | 'ManagerRejected'
    | 'EmployeeRejected'
    | 'NoLetterRequired'
  >;
  queryWorkflow?: Array<
    | 'EmployeeConfirmation'
    | 'EmployeeSignature'
    | 'ManagerConfirmationEmployeeConfirmation'
    | 'ManagerConfirmationEmployeeSignature'
    | 'ManagerSignatureEmployeeConfirmation'
    | 'ManagerSignatureEmployeeSignature'
    | 'ManagerConfirmationEmployeeNoActionNeeded'
    | 'NoActionNeeded'
    | 'AllocationByInCompanyManagerInvisibleForLineManager'
    | 'AllocationByInCompanyManagerVisibleForLineManager'
    | 'AllocationByLineManagerApprovalByInCompanyManager'
    | 'AllocationByLineManagerVisibleForInCompanyManager'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeSignature'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeNoActionNeeded'
  >;
  queryTemplate?: Array<string>;
  queryIsDesignReady?: boolean;
  queryPayoutDate?: string;
  queryPayoutState?: Array<
    'StandardPayout' | 'FullPayout' | 'DefinedPayoutEndOfFiscalYear' | 'NoPayout' | 'Irrelevant'
  >;
  queryLineManagerName?: string;
  queryLineManagerGid?: Array<string>;
  querySeasonId?: string;
  queryWorkflowInstanceState?: Array<
    | 'None'
    | 'InManagerReview'
    | 'ManagerValidated'
    | 'ReviewPeriodClosed'
    | 'Transferred'
    | 'ManagerRejected'
    | 'InAllocation'
    | 'AllocationFinished'
  >;
  queryMultiplier?: number;
  queryOverallTargetAchievement?: number;
  queryPayoutAmount?: number;
  queryPayoutCurrency?: Array<string>;
  queryIppAchievementValue?: string;
  queryIncentivePaymentType?: Array<string>;
  queryContractStatus?: Array<'Terminated' | 'Dormant' | 'Active' | 'Other'>;
  queryMeasurementDate?: string;
  queryMeritTitle?: Array<string>;
  queryEquityTitle?: Array<string>;
  queryEquitySubTitle?: Array<string>;
  queryManuallyChanged?: Array<'None' | 'Activated' | 'Deactivated'>;
  queryNewHire?: Array<'None' | 'Approved' | 'Reviewed' | 'ForReview' | 'Rejected'>;
  queryPromotion?: Array<'None' | 'Requested' | 'InProgress' | 'Rejected' | 'Finalized' | 'RequestedCb'>;
  queryTermination?: Array<'None' | 'ForReview' | 'Rejected' | 'Finalized'>;
  queryPopulationChange?: Array<'None' | 'MeritPopulation' | 'EquityPopulation'>;
  queryLineManagerFirstName?: Array<string>;
  queryLineManagerLastName?: Array<string>;
  queryCompanyManagerFirstName?: Array<string>;
  queryCompanyManagerGid?: Array<string>;
  queryCompanyManagerLastName?: Array<string>;
  queryTemplateName?: Array<string>;
  queryWorkflowType?: Array<
    | 'EmployeeConfirmation'
    | 'EmployeeSignature'
    | 'ManagerConfirmationEmployeeConfirmation'
    | 'ManagerConfirmationEmployeeSignature'
    | 'ManagerSignatureEmployeeConfirmation'
    | 'ManagerSignatureEmployeeSignature'
    | 'ManagerConfirmationEmployeeNoActionNeeded'
    | 'NoActionNeeded'
    | 'AllocationByInCompanyManagerInvisibleForLineManager'
    | 'AllocationByInCompanyManagerVisibleForLineManager'
    | 'AllocationByLineManagerApprovalByInCompanyManager'
    | 'AllocationByLineManagerVisibleForInCompanyManager'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeSignature'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeNoActionNeeded'
  >;
  queryAutoApprove?: boolean;
  queryApprovalRequired?: boolean;
  queryLetterState?: Array<
    | 'None'
    | 'Created'
    | 'InManagerReview'
    | 'InEmployeeReview'
    | 'Published'
    | 'ManagerRejected'
    | 'EmployeeRejected'
    | 'NoTafRequired'
    | 'InBusinessPartnerReview'
    | 'BusinessPartnerRejected'
  >;
  queryProcessState?: Array<
    | 'None'
    | 'Created'
    | 'InManagerReview'
    | 'InEmployeeReview'
    | 'Published'
    | 'ManagerRejected'
    | 'EmployeeRejected'
    | 'NoTafRequired'
    | 'InBusinessPartnerReview'
    | 'BusinessPartnerRejected'
  >;
  queryExportState?: Array<'Open' | 'Done'>;
  queryPayrollState?: Array<'Open' | 'Done'>;
  queryMeritRelevancy?: Array<'Relevant' | 'Excluded' | 'NoIncrease'>;
  queryApprovedByCompanyManager?: boolean;
  queryAllocationWorkflowType?: Array<
    | 'EmployeeConfirmation'
    | 'EmployeeSignature'
    | 'ManagerConfirmationEmployeeConfirmation'
    | 'ManagerConfirmationEmployeeSignature'
    | 'ManagerSignatureEmployeeConfirmation'
    | 'ManagerSignatureEmployeeSignature'
    | 'ManagerConfirmationEmployeeNoActionNeeded'
    | 'NoActionNeeded'
    | 'AllocationByInCompanyManagerInvisibleForLineManager'
    | 'AllocationByInCompanyManagerVisibleForLineManager'
    | 'AllocationByLineManagerApprovalByInCompanyManager'
    | 'AllocationByLineManagerVisibleForInCompanyManager'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeSignature'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeNoActionNeeded'
  >;
  queryReadyToPayroll?: boolean;
  queryEquityRelevancy?: Array<'Relevant' | 'Excluded' | 'NoIncrease'>;
  queryHasOtpIncrease?: boolean;
  queryIsOtpOnly?: boolean;
  queryPlanTitle?: Array<string>;
  queryLocalCurrency?: Array<string>;
  queryProposalAmount?: number;
  queryProposalAmountInEuro?: number;
  queryProposalDate?: string;
  queryProposalState?: Array<'Unknown' | 'Pending' | 'Approved' | 'AutoApproved' | 'Rejected'>;
  querySpecialPaymentReason?: Array<'Unknown' | 'SpecialProjectsInvolvement' | 'TemporaryEnlargedScope'>;
  querySpecialPaymentCompensationType?: Array<'Unknown' | 'Cash' | 'Equity'>;
  queryTemplateLetterName?: Array<string>;
  pagingPage?: number;
  pagingSize?: number;
  sortingOrderBy?: 'Asc' | 'Desc';
  sortingProperty?: string;
}

export interface SeasonsMeritAdminGetSeasonSettingsParams {
  seasonId: string;
}

export interface SeasonsMeritAdminGetSeasonsParams {
  id: string;
}

export interface SeasonsMeritAdminGetSimulationParams {
  simulationId: string;
}

export interface SeasonsMeritAdminGetSnapshotSeasonsParams {
  id: string;
  employeeId: string;
}

export interface SeasonsMeritAdminGetTreeOrganisationSnapshotsParams {
  seasonId: string;
  parentOrgCode?: string;
}

export interface SeasonsMeritAdminPartialUpdateEmployeeSnapshotsParams {
  snapshotId: string;
  updateEmployeeSnapshotPartial?: UpdateEmployeeSnapshotPartial;
}

export interface SeasonsMeritAdminPrePublishSimulationPublicationsParams {
  simulationId: string;
  positionName?: Array<string>;
  orgCode?: Array<string>;
  orgCodeStartsWith?: Array<string>;
  orgLevel?: Array<number>;
  orgSize?: Array<number>;
  mercerJobCode?: Array<string>;
  positionClass?: Array<number>;
  newPositionClass?: Array<number>;
  originalProposedPositionClass?: Array<number>;
  positionType?: Array<string>;
  countryIsoCode?: Array<string>;
  incumbentGid?: Array<string>;
  incumbentFirstName?: Array<string>;
  incumbentLastName?: Array<string>;
  incumbentCountryPlaceOfAction?: Array<string>;
  validationManagerId?: Array<string>;
  validationManagerGid?: Array<string>;
  validationManagerFirstName?: Array<string>;
  validationManagerLastName?: Array<string>;
  validationState?: Array<string>;
  placementState?: Array<string>;
  newHireState?: Array<string>;
  isLocked?: Array<boolean>;
  mercerJobFamily?: Array<string>;
  mercerJobSpecialization?: Array<string>;
  mercerJobSubFamily?: Array<string>;
  incumbentAre?: Array<string>;
  tag?: Array<string>;
  wasPromoted?: Array<boolean>;
  isTransferred?: Array<boolean>;
  simulationPublicationsPublishSimulation?: SimulationPublicationsPublishSimulation;
}

export interface SeasonsMeritAdminPublishSimulationPublicationsParams {
  simulationId: string;
  queryPositionName?: Array<string>;
  queryOrgCode?: Array<string>;
  queryOrgCodeStartsWith?: Array<string>;
  queryOrgLevel?: Array<number>;
  queryOrgSize?: Array<number>;
  queryMercerJobCode?: Array<string>;
  queryPositionClass?: Array<number>;
  queryNewPositionClass?: Array<number>;
  queryOriginalProposedPositionClass?: Array<number>;
  queryPositionType?: Array<string>;
  queryCountryIsoCode?: Array<string>;
  queryIncumbentGid?: Array<string>;
  queryIncumbentFirstName?: Array<string>;
  queryIncumbentLastName?: Array<string>;
  queryIncumbentCountryPlaceOfAction?: Array<string>;
  queryValidationManagerId?: Array<string>;
  queryValidationManagerGid?: Array<string>;
  queryValidationManagerFirstName?: Array<string>;
  queryValidationManagerLastName?: Array<string>;
  queryValidationState?: Array<string>;
  queryPlacementState?: Array<string>;
  queryNewHireState?: Array<string>;
  queryIsLocked?: Array<boolean>;
  queryMercerJobFamily?: Array<string>;
  queryMercerJobSpecialization?: Array<string>;
  queryMercerJobSubFamily?: Array<string>;
  queryIncumbentAre?: Array<string>;
  queryTag?: Array<string>;
  queryWasPromoted?: Array<boolean>;
  queryIsTransferred?: Array<boolean>;
  simulationPublicationsPublishSimulation?: SimulationPublicationsPublishSimulation;
}

export interface SeasonsMeritAdminQueryCandidatePoolsParams {
  seasonId?: string;
}

export interface SeasonsMeritAdminQueryEmployeeCandidatesParams {
  seasonId?: string;
  queryGid?: string;
  queryFirstname?: string;
  queryLastname?: string;
  queryPAOrgCode?: Array<string>;
  queryCandidatePoolTitle?: Array<string>;
  queryOrgCode?: string;
  queryGender?: Array<'Male' | 'Female' | 'Undefined'>;
  queryOrgLevel?: Array<number>;
  queryMercerPositionClass?: Array<number>;
  queryIsPlaced?: boolean;
  queryIsShortlisted?: boolean;
  sortingOrderBy?: 'Asc' | 'Desc';
  sortingProperty?: string;
  pagingPage?: number;
  pagingSize?: number;
}

export interface SeasonsMeritAdminQueryEmployeeSnapshotsParams {
  page?: number;
  size?: number;
}

export interface SeasonsMeritAdminQueryFieldValuesEmployeeCandidatesParams {
  targetProperty?: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8;
  seasonId?: string;
  pagingPage?: number;
  pagingSize?: number;
  gid?: string;
  firstname?: string;
  lastname?: string;
  pAOrgCode?: Array<string>;
  candidatePoolTitle?: Array<string>;
  orgCode?: string;
  gender?: Array<'Male' | 'Female' | 'Undefined'>;
  orgLevel?: Array<number>;
  mercerPositionClass?: Array<number>;
  isPlaced?: boolean;
  isShortlisted?: boolean;
}

export interface SeasonsMeritAdminQueryFieldValuesOrganisationSnapshotsParams {
  seasonId: string;
  targetProperty?: 0;
  orgCode?: string;
  page?: number;
  size?: number;
}

export interface SeasonsMeritAdminQueryFieldValuesRecordsParams {
  targetProperty: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12 | 13 | 14 | 15 | 16 | 17;
  memberId?: string;
  gid?: Array<string>;
  firstName?: Array<string>;
  lastName?: Array<string>;
  country?: Array<string>;
  are?: Array<string>;
  orgCode?: Array<string>;
  state?: Array<string>;
  planName?: Array<string>;
  startDate?: string;
  endDate?: string;
  assignmentId?: string;
  isDesignReady?: boolean;
  letterState?: Array<string>;
  payoutState?: Array<string>;
  template?: string;
  workflow?: string;
  seasonId?: string;
  workflowInstanceState?: Array<string>;
  lineManagerName?: string;
  lineManagerGid?: Array<string>;
  lineManagerPositionClass?: number;
  page?: number;
  size?: number;
}

export interface SeasonsMeritAdminQueryInformationOrganisationInformationSnapshotsParams {
  seasonId: string;
  orgCode?: Array<string>;
  orgName?: Array<string>;
  orgSize?: number;
  revenue?: number;
  headCount?: number;
  revenueOrgSize?: number;
  headCountOrgSize?: number;
  /** Export only: restricts the export to the organisations without organisation information or with a missing org size, like in the organisation list. Only the organisation filters (OrgCode, OrgName) apply then. */
  showOrganisationsWithoutOrgInfos?: boolean;
  page?: number;
  size?: number;
  orderBy?: 'Asc' | 'Desc';
  property?: string;
}

export interface SeasonsMeritAdminQueryInformationVisibilitySettingsParams {
  simulationId: string;
  queryTargetProperty?: 0 | 1 | 2 | 3;
  queryTargetTypeString?: string;
  querySimulationId?: string;
  queryPriority?: number;
  queryTitle?: string;
  queryAffectedCount?: number;
  queryType?: 'General' | 'Default';
  pagingPage?: number;
  pagingSize?: number;
  sortingOrderBy?: 'Asc' | 'Desc';
  sortingProperty?: string;
}

export interface SeasonsMeritAdminQueryMembersParams {
  page?: number;
  size?: number;
}

export interface SeasonsMeritAdminQueryOrganisationSnapshotsParams {
  seasonId: string;
  querySeasonId?: string;
  queryOrganisationId?: string;
  queryOrgCode?: Array<string>;
  queryOrgLevel?: number;
  queryParentOrgCode?: string;
  queryHeadId?: string;
  queryHeadGid?: string;
  queryHeadName?: string;
  queryPositionName?: string;
  queryAdditionalLineOne?: string;
  queryAdditionalLineTwo?: string;
  queryAdditionalLineThree?: string;
  queryAdditionalLineFour?: string;
  queryOrgName?: string;
  queryOrgType?: string;
  queryOrgLevelA?: string;
  queryOrgLevelB?: string;
  queryOrgLevelC?: string;
  queryOrgLevelD?: string;
  queryNumberOfEmployees?: number;
  queryHeadFirstname?: string;
  queryHeadLastname?: string;
  queryHeadPAOrgCode?: string;
  queryHeadPlaceOfAction?: string;
  queryHeadMercerJobCode?: string;
  queryHeadMercerPositionClass?: number;
  queryHeadManagementGroup?: string;
  queryOrgSize?: number;
  queryRevenue?: number;
  queryHeadCount?: number;
  queryRevenueOrgSize?: number;
  queryHeadCountOrgSize?: number;
  queryShowOrganisationsWithoutOrgInfos?: boolean;
  pagingPage?: number;
  pagingSize?: number;
  sortingOrderBy?: 'Asc' | 'Desc';
  sortingProperty?: string;
}

export interface SeasonsMeritAdminQueryOrganisationSnapshotsAndEmployeeSnapshotsSnapshotsParams {
  seasonId?: string;
  meritSeasonId?: string;
  search?: string;
  directs?: boolean;
  pagingPage?: number;
  pagingSize?: number;
  sortingOrderBy?: 'Asc' | 'Desc';
  sortingProperty?: string;
  impersonatedEmployee?: string;
}

export interface SeasonsMeritAdminQueryParentsOrganisationSnapshotsParams {
  seasonId: string;
  seasonId2: string;
  queryOrgCode?: string;
}

export interface SeasonsMeritAdminQueryPlanWithMissingIndividualValuesParams {
  seasonId?: string;
  queryKpiId?: string;
  queryAssignmentId?: string;
  queryOrgClusterNodeName?: string;
  queryGid?: string;
  queryLastname?: string;
  queryFirstname?: string;
  queryCountry?: string;
  queryOrgCode?: string;
  queryRecordStartdate?: string;
  queryPlanName?: string;
  pagingPage?: number;
  pagingSize?: number;
  sortingOrderBy?: 'Asc' | 'Desc';
  sortingProperty?: string;
}

export interface SeasonsMeritAdminQueryPlansParams {
  page?: number;
  size?: number;
  seasonId?: string;
}

export interface SeasonsMeritAdminQuerySeasonsParams {
  page?: number;
  size?: number;
  sortingOrderBy?: 'Asc' | 'Desc';
  sortingProperty?: string;
  seasonType?: Array<
    | 'Unknown'
    | 'SOG'
    | 'GBR'
    | 'Merit'
    | 'IncentiveV2'
    | 'SpecialPaymentCash'
    | 'SpecialPaymentEquity'
    | 'PositionEvaluation'
    | 'Restructuring'
  >;
  simulationState?: Array<
    | 'Created'
    | 'Edited'
    | 'Simulating'
    | 'Simulated'
    | 'RecalculationRequired'
    | 'Ready'
    | 'Frozen'
    | 'Recalculating'
    | 'InAllocation'
    | 'PrePublished'
    | 'Calculating'
    | 'CalculationRequired'
    | 'Calculated'
    | 'Published'
    | 'UpdatingData'
  >;
  queryManagerEndDateAt?: string;
  queryPartnerEndDateAt?: string;
  querySeasonType?: Array<
    | 'Unknown'
    | 'SOG'
    | 'GBR'
    | 'Merit'
    | 'IncentiveV2'
    | 'SpecialPaymentCash'
    | 'SpecialPaymentEquity'
    | 'PositionEvaluation'
    | 'Restructuring'
  >;
  querySimulationState?: Array<
    | 'Created'
    | 'Edited'
    | 'Simulating'
    | 'Simulated'
    | 'RecalculationRequired'
    | 'Ready'
    | 'Frozen'
    | 'Recalculating'
    | 'InAllocation'
    | 'PrePublished'
    | 'Calculating'
    | 'CalculationRequired'
    | 'Calculated'
    | 'Published'
    | 'UpdatingData'
  >;
}

export interface SeasonsMeritAdminQuerySimulationParams {
  seasonId: string;
}

export interface SeasonsMeritAdminRecalculateParentSettingsPopulationSimulationPopulationsParams {
  simulationId: string;
  parentSettingId: string;
  settingsType?:
    | 'Merit'
    | 'Equity'
    | 'EquitySub'
    | 'Validation'
    | 'Placement'
    | 'ValidationHr'
    | 'PlacementHr'
    | 'Other'
    | 'NewHirePlan'
    | 'NewHireMerit'
    | 'NewHireEquity'
    | 'NewHireEquitySub'
    | 'IndividualMultiplier'
    | 'InformationVisibility'
    | 'Incentive'
    | 'NewHireIncentive'
    | 'IncentiveSub'
    | 'NewHireIncentiveSub';
}

export interface SeasonsMeritAdminRecalculatePlanPopulationsParams {
  seasonId: string;
}

export interface SeasonsMeritAdminRecalculateSettingsPopulationSimulationPopulationsParams {
  simulationId: string;
  settingsType?:
    | 'Merit'
    | 'Equity'
    | 'EquitySub'
    | 'Validation'
    | 'Placement'
    | 'ValidationHr'
    | 'PlacementHr'
    | 'Other'
    | 'NewHirePlan'
    | 'NewHireMerit'
    | 'NewHireEquity'
    | 'NewHireEquitySub'
    | 'IndividualMultiplier'
    | 'InformationVisibility'
    | 'Incentive'
    | 'NewHireIncentive'
    | 'IncentiveSub'
    | 'NewHireIncentiveSub';
}

export interface SeasonsMeritAdminSavePlanPopulationsParams {
  id: string;
}

export interface SeasonsMeritAdminSaveSeasonPopulationsParams {
  seasonId: string;
}

export interface SeasonsMeritAdminSimulateEquitySettingsPopulationSimulationPopulationsParams {
  seasonId: string;
  settingsId: string;
  simulationId: string;
  page?: number;
  size?: number;
  ruleSet?: RuleSet;
}

export interface SeasonsMeritAdminSimulateEquitySubSettingsPopulationSimulationPopulationsParams {
  seasonId: string;
  settingsId: string;
  subSettingsId: string;
  simulationId: string;
  page?: number;
  size?: number;
  ruleSet?: RuleSet;
}

export interface SeasonsMeritAdminSimulateMeritPopulationSimulationPopulationsParams {
  seasonId: string;
  settingsId: string;
  simulationId: string;
  page?: number;
  size?: number;
  ruleSet?: RuleSet;
}

export interface SeasonsMeritAdminSimulatePlanPopulationsParams {
  id: string;
  page?: number;
  size?: number;
  ruleSet?: RuleSet;
}

export interface SeasonsMeritAdminSimulateRuleInformationVisibilitySettingsParams {
  settingsId: string;
  simulationId: string;
  page?: number;
  size?: number;
  ruleSet?: RuleSet;
}

export interface SeasonsMeritAdminSimulateSeasonPopulationsParams {
  seasonId: string;
  page?: number;
  size?: number;
  _export?: boolean;
  ruleSet?: RuleSet;
}

export interface SeasonsMeritAdminUnPrePublishSimulationPublicationsParams {
  simulationId: string;
}

export interface SeasonsMeritAdminUnPublishSimulationPublicationsParams {
  simulationId: string;
  queryPositionName?: Array<string>;
  queryOrgCode?: Array<string>;
  queryOrgCodeStartsWith?: Array<string>;
  queryOrgLevel?: Array<number>;
  queryOrgSize?: Array<number>;
  queryMercerJobCode?: Array<string>;
  queryPositionClass?: Array<number>;
  queryNewPositionClass?: Array<number>;
  queryOriginalProposedPositionClass?: Array<number>;
  queryPositionType?: Array<string>;
  queryCountryIsoCode?: Array<string>;
  queryIncumbentGid?: Array<string>;
  queryIncumbentFirstName?: Array<string>;
  queryIncumbentLastName?: Array<string>;
  queryIncumbentCountryPlaceOfAction?: Array<string>;
  queryValidationManagerId?: Array<string>;
  queryValidationManagerGid?: Array<string>;
  queryValidationManagerFirstName?: Array<string>;
  queryValidationManagerLastName?: Array<string>;
  queryValidationState?: Array<string>;
  queryPlacementState?: Array<string>;
  queryNewHireState?: Array<string>;
  queryIsLocked?: Array<boolean>;
  queryMercerJobFamily?: Array<string>;
  queryMercerJobSpecialization?: Array<string>;
  queryMercerJobSubFamily?: Array<string>;
  queryIncumbentAre?: Array<string>;
  queryTag?: Array<string>;
  queryWasPromoted?: Array<boolean>;
  queryIsTransferred?: Array<boolean>;
  unPublishSimulation?: UnPublishSimulation;
}

export interface SeasonsMeritAdminUpdateBenchmarkValuesSnapshotsParams {
  updateSnapshotBenchmarkValues?: UpdateSnapshotBenchmarkValues;
}

export interface SeasonsMeritAdminUpdateBucketComponentBatchBudgetComponentsParams {
  budgetBucketId: string;
  updateManyBucketComponents?: UpdateManyBucketComponents;
}

export interface SeasonsMeritAdminUpdateBucketComponentBudgetComponentsParams {
  budgetBucketId: string;
  updateBucketComponent?: UpdateBucketComponent;
}

export interface SeasonsMeritAdminUpdateBudgetBucketsParams {
  id: string;
  updateBudgetBucket?: UpdateBudgetBucket;
}

export interface SeasonsMeritAdminUpdateCandidatePoolsParams {
  id: string;
  updateCandidatePool?: UpdateCandidatePool;
}

export interface SeasonsMeritAdminUpdateEmployeeSnapshotsParams {
  updateEmployeeSnapshot?: UpdateEmployeeSnapshot;
}

export interface SeasonsMeritAdminUpdateInformationVisibilitySettingsParams {
  settingsId: string;
  simulationId: string;
  updateInformationVisibilitySettings?: UpdateInformationVisibilitySettings;
}

export interface SeasonsMeritAdminUpdateManyBudgetBucketsParams {
  updateManyBudgetBuckets?: UpdateManyBudgetBuckets;
}

export interface SeasonsMeritAdminUpdateMembersParams {
  updateMember?: UpdateMember;
}

export interface SeasonsMeritAdminUpdateOrganisationInformationSnapshotsParams {
  seasonId: string;
  id: string;
  updateOrganisationInformationSnapshot?: UpdateOrganisationInformationSnapshot;
}

export interface SeasonsMeritAdminUpdatePlanSettingsParams {
  id: string;
  planId: string;
  updatePlanSettings?: UpdatePlanSettings;
}

export interface SeasonsMeritAdminUpdatePlansParams {
  id: string;
  updatePlan?: UpdatePlan;
}

export interface SeasonsMeritAdminUpdatePublicationSettingsPublicationSettingsParams {
  seasonId: string;
  updatePublicationSettings?: UpdatePublicationSettings;
}

export interface SeasonsMeritAdminUpdateSeasonCommunicationSettingsParams {
  seasonId: string;
  updateCommunicationSettings?: UpdateCommunicationSettings;
}

export interface SeasonsMeritAdminUpdateSeasonSettingsParams {
  setSeasonSettings?: SetSeasonSettings;
}

export interface SeasonsMeritAdminUpdateSeasonsParams {
  updateSeason?: UpdateSeason;
}

export interface SeasonsMeritAdminUpdateSimulationParams {
  simulationId: string;
  seasonsSimulationsUpdateSimulation?: SeasonsSimulationsUpdateSimulation;
}

export interface SeasonsMeritAdminUpdateSimulationMembersSimulationParams {
  seasonId: string;
  simulationId: string;
  updateSimulationMembers?: UpdateSimulationMembers;
}

export interface SimulateMeritIncentiveSettingsPopulationSimulationPopulationsParams {
  seasonId: string;
  settingsId: string;
  simulationId: string;
  page?: number;
  size?: number;
  ruleSet?: RuleSet;
}

export interface SimulateMeritincentiveSubSettingsPopulationSimulationPopulationsParams {
  seasonId: string;
  settingsId: string;
  subSettingsId: string;
  simulationId: string;
  page?: number;
  size?: number;
  ruleSet?: RuleSet;
}

@Injectable({
  providedIn: 'root'
})
export class SeasonsMeritAdminService extends BaseService {
  constructor(
    httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string | string[],
    @Optional() configuration: Configuration
  ) {
    super(httpClient, basePath, configuration);
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public importOrganisationSnapshots(
    requestParameters?: ImportOrganisationSnapshotsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Import>;
  public importOrganisationSnapshots(
    requestParameters?: ImportOrganisationSnapshotsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Import>>;
  public importOrganisationSnapshots(
    requestParameters?: ImportOrganisationSnapshotsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Import>>;
  public importOrganisationSnapshots(
    requestParameters?: ImportOrganisationSnapshotsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('importOrganisationSnapshots', { seasonId });
    return this.sendRequest(args, {
      method: 'put',
      path: `/admin/api/v1/merit/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/snapshots/organisations/import`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.loadImport,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsMeritAdminCalculateManySimulation(
    requestParameters?: SeasonsMeritAdminCalculateManySimulationParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfCalculationStatus>;
  public seasonsMeritAdminCalculateManySimulation(
    requestParameters?: SeasonsMeritAdminCalculateManySimulationParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfCalculationStatus>>;
  public seasonsMeritAdminCalculateManySimulation(
    requestParameters?: SeasonsMeritAdminCalculateManySimulationParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfCalculationStatus>>;
  public seasonsMeritAdminCalculateManySimulation(
    requestParameters?: SeasonsMeritAdminCalculateManySimulationParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('seasonsMeritAdminCalculateManySimulation', { seasonId });
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v1/merit/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/simulations/calculate`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.calculateManySimulations,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsMeritAdminCalculateSimulation(
    requestParameters?: SeasonsMeritAdminCalculateSimulationParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfMassSimulationCalculationMetadata>;
  public seasonsMeritAdminCalculateSimulation(
    requestParameters?: SeasonsMeritAdminCalculateSimulationParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfMassSimulationCalculationMetadata>>;
  public seasonsMeritAdminCalculateSimulation(
    requestParameters?: SeasonsMeritAdminCalculateSimulationParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfMassSimulationCalculationMetadata>>;
  public seasonsMeritAdminCalculateSimulation(
    requestParameters?: SeasonsMeritAdminCalculateSimulationParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('seasonsMeritAdminCalculateSimulation', { seasonId });
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v1/merit/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/simulations/mass-calculate`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.calculateSimulation,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsMeritAdminChangePrioritiesInformationVisibilitySettings(
    requestParameters?: SeasonsMeritAdminChangePrioritiesInformationVisibilitySettingsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<StatusResponse>;
  public seasonsMeritAdminChangePrioritiesInformationVisibilitySettings(
    requestParameters?: SeasonsMeritAdminChangePrioritiesInformationVisibilitySettingsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<StatusResponse>>;
  public seasonsMeritAdminChangePrioritiesInformationVisibilitySettings(
    requestParameters?: SeasonsMeritAdminChangePrioritiesInformationVisibilitySettingsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<StatusResponse>>;
  public seasonsMeritAdminChangePrioritiesInformationVisibilitySettings(
    requestParameters?: SeasonsMeritAdminChangePrioritiesInformationVisibilitySettingsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    this.checkRequired('seasonsMeritAdminChangePrioritiesInformationVisibilitySettings', { simulationId });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/admin/api/v1/merit/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/settings/information-visibility/priorities`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.changeManyPriorities,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsMeritAdminChangePrioritiesPlans(
    requestParameters?: SeasonsMeritAdminChangePrioritiesPlansParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<any>;
  public seasonsMeritAdminChangePrioritiesPlans(
    requestParameters?: SeasonsMeritAdminChangePrioritiesPlansParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpResponse<any>>;
  public seasonsMeritAdminChangePrioritiesPlans(
    requestParameters?: SeasonsMeritAdminChangePrioritiesPlansParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpEvent<any>>;
  public seasonsMeritAdminChangePrioritiesPlans(
    requestParameters?: SeasonsMeritAdminChangePrioritiesPlansParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'patch',
      path: `/admin/api/v1/merit/plans/priorities`,
      accepts: [],
      body: requestParameters?.changeManyPriorities,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsMeritAdminCreateBudgetComponents(
    requestParameters?: SeasonsMeritAdminCreateBudgetComponentsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<BucketComponentModificationResponse>;
  public seasonsMeritAdminCreateBudgetComponents(
    requestParameters?: SeasonsMeritAdminCreateBudgetComponentsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<BucketComponentModificationResponse>>;
  public seasonsMeritAdminCreateBudgetComponents(
    requestParameters?: SeasonsMeritAdminCreateBudgetComponentsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<BucketComponentModificationResponse>>;
  public seasonsMeritAdminCreateBudgetComponents(
    requestParameters?: SeasonsMeritAdminCreateBudgetComponentsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const budgetBucketId = requestParameters?.budgetBucketId;
    this.checkRequired('seasonsMeritAdminCreateBudgetComponents', { budgetBucketId });
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v1/merit/budget-bucket/${this.configuration.encodeParam({ name: 'budgetBucketId', value: budgetBucketId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/budget-components`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.createBucketComponent,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsMeritAdminCreateCandidatePools(
    requestParameters?: SeasonsMeritAdminCreateCandidatePoolsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<CandidatePoolModel>;
  public seasonsMeritAdminCreateCandidatePools(
    requestParameters?: SeasonsMeritAdminCreateCandidatePoolsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<CandidatePoolModel>>;
  public seasonsMeritAdminCreateCandidatePools(
    requestParameters?: SeasonsMeritAdminCreateCandidatePoolsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<CandidatePoolModel>>;
  public seasonsMeritAdminCreateCandidatePools(
    requestParameters?: SeasonsMeritAdminCreateCandidatePoolsParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v1/merit/candidate-pools`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.createCandidatePool,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsMeritAdminCreateEmployeeSnapshots(
    requestParameters?: SeasonsMeritAdminCreateEmployeeSnapshotsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<EmployeeSnapshotsEmployeeSnapshot>;
  public seasonsMeritAdminCreateEmployeeSnapshots(
    requestParameters?: SeasonsMeritAdminCreateEmployeeSnapshotsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<EmployeeSnapshotsEmployeeSnapshot>>;
  public seasonsMeritAdminCreateEmployeeSnapshots(
    requestParameters?: SeasonsMeritAdminCreateEmployeeSnapshotsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<EmployeeSnapshotsEmployeeSnapshot>>;
  public seasonsMeritAdminCreateEmployeeSnapshots(
    requestParameters?: SeasonsMeritAdminCreateEmployeeSnapshotsParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v1/merit/employee-snapshots`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.createEmployeeSnapshot,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsMeritAdminCreateInformationVisibilitySettings(
    requestParameters?: SeasonsMeritAdminCreateInformationVisibilitySettingsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<MeritInformationVisibilitySettingsModel>;
  public seasonsMeritAdminCreateInformationVisibilitySettings(
    requestParameters?: SeasonsMeritAdminCreateInformationVisibilitySettingsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<MeritInformationVisibilitySettingsModel>>;
  public seasonsMeritAdminCreateInformationVisibilitySettings(
    requestParameters?: SeasonsMeritAdminCreateInformationVisibilitySettingsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<MeritInformationVisibilitySettingsModel>>;
  public seasonsMeritAdminCreateInformationVisibilitySettings(
    requestParameters?: SeasonsMeritAdminCreateInformationVisibilitySettingsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    this.checkRequired('seasonsMeritAdminCreateInformationVisibilitySettings', { simulationId });
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v1/merit/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/settings/information-visibility`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.createInformationVisibilitySettings,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsMeritAdminCreateManyBudgetComponents(
    requestParameters?: SeasonsMeritAdminCreateManyBudgetComponentsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<BucketComponentModificationResponse>;
  public seasonsMeritAdminCreateManyBudgetComponents(
    requestParameters?: SeasonsMeritAdminCreateManyBudgetComponentsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<BucketComponentModificationResponse>>;
  public seasonsMeritAdminCreateManyBudgetComponents(
    requestParameters?: SeasonsMeritAdminCreateManyBudgetComponentsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<BucketComponentModificationResponse>>;
  public seasonsMeritAdminCreateManyBudgetComponents(
    requestParameters?: SeasonsMeritAdminCreateManyBudgetComponentsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const budgetBucketId = requestParameters?.budgetBucketId;
    this.checkRequired('seasonsMeritAdminCreateManyBudgetComponents', { budgetBucketId });
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v1/merit/budget-bucket/${this.configuration.encodeParam({ name: 'budgetBucketId', value: budgetBucketId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/budget-components/batch`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.createManyBucketComponents,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsMeritAdminCreateMembers(
    requestParameters?: SeasonsMeritAdminCreateMembersParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<MemberModel>;
  public seasonsMeritAdminCreateMembers(
    requestParameters?: SeasonsMeritAdminCreateMembersParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<MemberModel>>;
  public seasonsMeritAdminCreateMembers(
    requestParameters?: SeasonsMeritAdminCreateMembersParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<MemberModel>>;
  public seasonsMeritAdminCreateMembers(
    requestParameters?: SeasonsMeritAdminCreateMembersParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v1/merit/members`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.createMember,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsMeritAdminCreateOrganisationInformationSnapshots(
    requestParameters?: SeasonsMeritAdminCreateOrganisationInformationSnapshotsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<OrganisationInformationSnapshotModel>;
  public seasonsMeritAdminCreateOrganisationInformationSnapshots(
    requestParameters?: SeasonsMeritAdminCreateOrganisationInformationSnapshotsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<OrganisationInformationSnapshotModel>>;
  public seasonsMeritAdminCreateOrganisationInformationSnapshots(
    requestParameters?: SeasonsMeritAdminCreateOrganisationInformationSnapshotsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<OrganisationInformationSnapshotModel>>;
  public seasonsMeritAdminCreateOrganisationInformationSnapshots(
    requestParameters?: SeasonsMeritAdminCreateOrganisationInformationSnapshotsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('seasonsMeritAdminCreateOrganisationInformationSnapshots', { seasonId });
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v1/merit/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/snapshots/organisations/information`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.createOrganisationInformationSnapshot,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsMeritAdminCreatePlanSettings(
    requestParameters?: SeasonsMeritAdminCreatePlanSettingsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PlanSettingsModel>;
  public seasonsMeritAdminCreatePlanSettings(
    requestParameters?: SeasonsMeritAdminCreatePlanSettingsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PlanSettingsModel>>;
  public seasonsMeritAdminCreatePlanSettings(
    requestParameters?: SeasonsMeritAdminCreatePlanSettingsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PlanSettingsModel>>;
  public seasonsMeritAdminCreatePlanSettings(
    requestParameters?: SeasonsMeritAdminCreatePlanSettingsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const planId = requestParameters?.planId;
    this.checkRequired('seasonsMeritAdminCreatePlanSettings', { planId });
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v1/merit/season-plans/${this.configuration.encodeParam({ name: 'planId', value: planId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/settings`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.createPlanSettings,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsMeritAdminCreatePlans(
    requestParameters?: SeasonsMeritAdminCreatePlansParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PlanModel>;
  public seasonsMeritAdminCreatePlans(
    requestParameters?: SeasonsMeritAdminCreatePlansParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PlanModel>>;
  public seasonsMeritAdminCreatePlans(
    requestParameters?: SeasonsMeritAdminCreatePlansParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PlanModel>>;
  public seasonsMeritAdminCreatePlans(
    requestParameters?: SeasonsMeritAdminCreatePlansParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v1/merit/plans`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.createPlan,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsMeritAdminCreatePublicationSettings(
    requestParameters?: SeasonsMeritAdminCreatePublicationSettingsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PublicationSettingsModel>;
  public seasonsMeritAdminCreatePublicationSettings(
    requestParameters?: SeasonsMeritAdminCreatePublicationSettingsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PublicationSettingsModel>>;
  public seasonsMeritAdminCreatePublicationSettings(
    requestParameters?: SeasonsMeritAdminCreatePublicationSettingsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PublicationSettingsModel>>;
  public seasonsMeritAdminCreatePublicationSettings(
    requestParameters?: SeasonsMeritAdminCreatePublicationSettingsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('seasonsMeritAdminCreatePublicationSettings', { seasonId });
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v1/merit/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/publication-settings`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.createPublicationSettings,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsMeritAdminCreateSeasons(
    requestParameters?: SeasonsMeritAdminCreateSeasonsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<SeasonModel>;
  public seasonsMeritAdminCreateSeasons(
    requestParameters?: SeasonsMeritAdminCreateSeasonsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<SeasonModel>>;
  public seasonsMeritAdminCreateSeasons(
    requestParameters?: SeasonsMeritAdminCreateSeasonsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<SeasonModel>>;
  public seasonsMeritAdminCreateSeasons(
    requestParameters?: SeasonsMeritAdminCreateSeasonsParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v1/merit/seasons`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.createSeason,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsMeritAdminCreateSimulation(
    requestParameters?: SeasonsMeritAdminCreateSimulationParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfIMetadata>;
  public seasonsMeritAdminCreateSimulation(
    requestParameters?: SeasonsMeritAdminCreateSimulationParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfIMetadata>>;
  public seasonsMeritAdminCreateSimulation(
    requestParameters?: SeasonsMeritAdminCreateSimulationParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfIMetadata>>;
  public seasonsMeritAdminCreateSimulation(
    requestParameters?: SeasonsMeritAdminCreateSimulationParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v1/merit/simulations`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.seasonsSimulationsCreateSimulation,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsMeritAdminDeleteBudgetComponents(
    requestParameters?: SeasonsMeritAdminDeleteBudgetComponentsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<any>;
  public seasonsMeritAdminDeleteBudgetComponents(
    requestParameters?: SeasonsMeritAdminDeleteBudgetComponentsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpResponse<any>>;
  public seasonsMeritAdminDeleteBudgetComponents(
    requestParameters?: SeasonsMeritAdminDeleteBudgetComponentsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpEvent<any>>;
  public seasonsMeritAdminDeleteBudgetComponents(
    requestParameters?: SeasonsMeritAdminDeleteBudgetComponentsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const budgetBucketId = requestParameters?.budgetBucketId;
    this.checkRequired('seasonsMeritAdminDeleteBudgetComponents', { budgetBucketId });
    return this.sendRequest(args, {
      method: 'delete',
      path: `/admin/api/v1/merit/budget-bucket/${this.configuration.encodeParam({ name: 'budgetBucketId', value: budgetBucketId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/budget-components`,
      accepts: []
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsMeritAdminDeleteCandidatePools(
    requestParameters?: SeasonsMeritAdminDeleteCandidatePoolsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<any>;
  public seasonsMeritAdminDeleteCandidatePools(
    requestParameters?: SeasonsMeritAdminDeleteCandidatePoolsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpResponse<any>>;
  public seasonsMeritAdminDeleteCandidatePools(
    requestParameters?: SeasonsMeritAdminDeleteCandidatePoolsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpEvent<any>>;
  public seasonsMeritAdminDeleteCandidatePools(
    requestParameters?: SeasonsMeritAdminDeleteCandidatePoolsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('seasonsMeritAdminDeleteCandidatePools', { id });
    return this.sendRequest(args, {
      method: 'delete',
      path: `/admin/api/v1/merit/candidate-pools/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: []
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsMeritAdminDeleteEmployeeSnapshots(
    requestParameters?: SeasonsMeritAdminDeleteEmployeeSnapshotsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<any>;
  public seasonsMeritAdminDeleteEmployeeSnapshots(
    requestParameters?: SeasonsMeritAdminDeleteEmployeeSnapshotsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpResponse<any>>;
  public seasonsMeritAdminDeleteEmployeeSnapshots(
    requestParameters?: SeasonsMeritAdminDeleteEmployeeSnapshotsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpEvent<any>>;
  public seasonsMeritAdminDeleteEmployeeSnapshots(
    requestParameters?: SeasonsMeritAdminDeleteEmployeeSnapshotsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const snapshotId = requestParameters?.snapshotId;
    this.checkRequired('seasonsMeritAdminDeleteEmployeeSnapshots', { snapshotId });
    return this.sendRequest(args, {
      method: 'delete',
      path: `/admin/api/v1/merit/employee-snapshots/${this.configuration.encodeParam({ name: 'snapshotId', value: snapshotId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: []
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsMeritAdminDeleteMembers(
    requestParameters?: SeasonsMeritAdminDeleteMembersParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<any>;
  public seasonsMeritAdminDeleteMembers(
    requestParameters?: SeasonsMeritAdminDeleteMembersParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpResponse<any>>;
  public seasonsMeritAdminDeleteMembers(
    requestParameters?: SeasonsMeritAdminDeleteMembersParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpEvent<any>>;
  public seasonsMeritAdminDeleteMembers(
    requestParameters?: SeasonsMeritAdminDeleteMembersParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('seasonsMeritAdminDeleteMembers', { id });
    return this.sendRequest(args, {
      method: 'delete',
      path: `/admin/api/v1/merit/members/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: []
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsMeritAdminDeleteOrganisationInformationSnapshots(
    requestParameters?: SeasonsMeritAdminDeleteOrganisationInformationSnapshotsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<boolean>;
  public seasonsMeritAdminDeleteOrganisationInformationSnapshots(
    requestParameters?: SeasonsMeritAdminDeleteOrganisationInformationSnapshotsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<boolean>>;
  public seasonsMeritAdminDeleteOrganisationInformationSnapshots(
    requestParameters?: SeasonsMeritAdminDeleteOrganisationInformationSnapshotsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<boolean>>;
  public seasonsMeritAdminDeleteOrganisationInformationSnapshots(
    requestParameters?: SeasonsMeritAdminDeleteOrganisationInformationSnapshotsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('seasonsMeritAdminDeleteOrganisationInformationSnapshots', { id, seasonId });
    return this.sendRequest(args, {
      method: 'delete',
      path: `/admin/api/v1/merit/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/snapshots/organisations/information/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsMeritAdminDeletePlanSettings(
    requestParameters?: SeasonsMeritAdminDeletePlanSettingsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<any>;
  public seasonsMeritAdminDeletePlanSettings(
    requestParameters?: SeasonsMeritAdminDeletePlanSettingsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpResponse<any>>;
  public seasonsMeritAdminDeletePlanSettings(
    requestParameters?: SeasonsMeritAdminDeletePlanSettingsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpEvent<any>>;
  public seasonsMeritAdminDeletePlanSettings(
    requestParameters?: SeasonsMeritAdminDeletePlanSettingsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    const planId = requestParameters?.planId;
    this.checkRequired('seasonsMeritAdminDeletePlanSettings', { id, planId });
    return this.sendRequest(args, {
      method: 'delete',
      path: `/admin/api/v1/merit/season-plans/${this.configuration.encodeParam({ name: 'planId', value: planId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/settings/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: []
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsMeritAdminDeletePlans(
    requestParameters?: SeasonsMeritAdminDeletePlansParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<any>;
  public seasonsMeritAdminDeletePlans(
    requestParameters?: SeasonsMeritAdminDeletePlansParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpResponse<any>>;
  public seasonsMeritAdminDeletePlans(
    requestParameters?: SeasonsMeritAdminDeletePlansParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpEvent<any>>;
  public seasonsMeritAdminDeletePlans(
    requestParameters?: SeasonsMeritAdminDeletePlansParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('seasonsMeritAdminDeletePlans', { id });
    return this.sendRequest(args, {
      method: 'delete',
      path: `/admin/api/v1/merit/plans/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: []
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsMeritAdminDeleteSeasons(
    requestParameters?: SeasonsMeritAdminDeleteSeasonsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<any>;
  public seasonsMeritAdminDeleteSeasons(
    requestParameters?: SeasonsMeritAdminDeleteSeasonsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpResponse<any>>;
  public seasonsMeritAdminDeleteSeasons(
    requestParameters?: SeasonsMeritAdminDeleteSeasonsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpEvent<any>>;
  public seasonsMeritAdminDeleteSeasons(
    requestParameters?: SeasonsMeritAdminDeleteSeasonsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('seasonsMeritAdminDeleteSeasons', { id });
    return this.sendRequest(args, {
      method: 'delete',
      path: `/admin/api/v1/merit/seasons/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: []
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsMeritAdminDeleteSimulationSettings(
    requestParameters?: SeasonsMeritAdminDeleteSimulationSettingsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<any>;
  public seasonsMeritAdminDeleteSimulationSettings(
    requestParameters?: SeasonsMeritAdminDeleteSimulationSettingsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpResponse<any>>;
  public seasonsMeritAdminDeleteSimulationSettings(
    requestParameters?: SeasonsMeritAdminDeleteSimulationSettingsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpEvent<any>>;
  public seasonsMeritAdminDeleteSimulationSettings(
    requestParameters?: SeasonsMeritAdminDeleteSimulationSettingsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    const seasonId = requestParameters?.seasonId;
    const simulationId = requestParameters?.simulationId;
    this.checkRequired('seasonsMeritAdminDeleteSimulationSettings', { id, seasonId, simulationId });
    return this.sendRequest(args, {
      method: 'delete',
      path: `/admin/api/v1/merit/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/settings/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: [],
      query: { settingsType: requestParameters?.settingsType }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsMeritAdminDuplicateSeasons(
    requestParameters?: SeasonsMeritAdminDuplicateSeasonsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfSimpleStatusMetadata>;
  public seasonsMeritAdminDuplicateSeasons(
    requestParameters?: SeasonsMeritAdminDuplicateSeasonsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfSimpleStatusMetadata>>;
  public seasonsMeritAdminDuplicateSeasons(
    requestParameters?: SeasonsMeritAdminDuplicateSeasonsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfSimpleStatusMetadata>>;
  public seasonsMeritAdminDuplicateSeasons(
    requestParameters?: SeasonsMeritAdminDuplicateSeasonsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('seasonsMeritAdminDuplicateSeasons', { id });
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v1/merit/seasons/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/duplicate`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.duplicateSeason,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsMeritAdminExportEmployeeCandidates(
    requestParameters?: SeasonsMeritAdminExportEmployeeCandidatesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfExportStatusMetadata>;
  public seasonsMeritAdminExportEmployeeCandidates(
    requestParameters?: SeasonsMeritAdminExportEmployeeCandidatesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfExportStatusMetadata>>;
  public seasonsMeritAdminExportEmployeeCandidates(
    requestParameters?: SeasonsMeritAdminExportEmployeeCandidatesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfExportStatusMetadata>>;
  public seasonsMeritAdminExportEmployeeCandidates(
    requestParameters?: SeasonsMeritAdminExportEmployeeCandidatesParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('seasonsMeritAdminExportEmployeeCandidates', { seasonId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/merit/employee-candidates/export`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        'Query.Gid': requestParameters?.queryGid,
        'Query.Firstname': requestParameters?.queryFirstname,
        'Query.Lastname': requestParameters?.queryLastname,
        'Query.PAOrgCode': requestParameters?.queryPAOrgCode,
        'Query.CandidatePoolTitle': requestParameters?.queryCandidatePoolTitle,
        'Query.OrgCode': requestParameters?.queryOrgCode,
        'Query.Gender': requestParameters?.queryGender,
        'Query.OrgLevel': requestParameters?.queryOrgLevel,
        'Query.MercerPositionClass': requestParameters?.queryMercerPositionClass,
        'Query.IsPlaced': requestParameters?.queryIsPlaced,
        'Query.IsShortlisted': requestParameters?.queryIsShortlisted,
        SeasonId: seasonId,
        RecordIds: requestParameters?.recordIds,
        State: requestParameters?.state,
        Filename: requestParameters?.filename
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsMeritAdminExportOrganisationInformationSnapshots(
    requestParameters?: SeasonsMeritAdminExportOrganisationInformationSnapshotsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfExportStatusMetadata>;
  public seasonsMeritAdminExportOrganisationInformationSnapshots(
    requestParameters?: SeasonsMeritAdminExportOrganisationInformationSnapshotsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfExportStatusMetadata>>;
  public seasonsMeritAdminExportOrganisationInformationSnapshots(
    requestParameters?: SeasonsMeritAdminExportOrganisationInformationSnapshotsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfExportStatusMetadata>>;
  public seasonsMeritAdminExportOrganisationInformationSnapshots(
    requestParameters?: SeasonsMeritAdminExportOrganisationInformationSnapshotsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('seasonsMeritAdminExportOrganisationInformationSnapshots', { seasonId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/merit/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/snapshots/organisations/information/export`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        OrgCode: requestParameters?.orgCode,
        OrgName: requestParameters?.orgName,
        OrgSize: requestParameters?.orgSize,
        Revenue: requestParameters?.revenue,
        HeadCount: requestParameters?.headCount,
        RevenueOrgSize: requestParameters?.revenueOrgSize,
        HeadCountOrgSize: requestParameters?.headCountOrgSize,
        ShowOrganisationsWithoutOrgInfos: requestParameters?.showOrganisationsWithoutOrgInfos,
        fileName: requestParameters?.fileName
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsMeritAdminExportOrganisationSnapshots(
    requestParameters?: SeasonsMeritAdminExportOrganisationSnapshotsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfExportStatusMetadata>;
  public seasonsMeritAdminExportOrganisationSnapshots(
    requestParameters?: SeasonsMeritAdminExportOrganisationSnapshotsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfExportStatusMetadata>>;
  public seasonsMeritAdminExportOrganisationSnapshots(
    requestParameters?: SeasonsMeritAdminExportOrganisationSnapshotsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfExportStatusMetadata>>;
  public seasonsMeritAdminExportOrganisationSnapshots(
    requestParameters?: SeasonsMeritAdminExportOrganisationSnapshotsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('seasonsMeritAdminExportOrganisationSnapshots', { seasonId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/merit/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/snapshots/organisations/export`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsMeritAdminExportPlanWithMissingIndividualValues(
    requestParameters?: SeasonsMeritAdminExportPlanWithMissingIndividualValuesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfExportStatusMetadata>;
  public seasonsMeritAdminExportPlanWithMissingIndividualValues(
    requestParameters?: SeasonsMeritAdminExportPlanWithMissingIndividualValuesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfExportStatusMetadata>>;
  public seasonsMeritAdminExportPlanWithMissingIndividualValues(
    requestParameters?: SeasonsMeritAdminExportPlanWithMissingIndividualValuesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfExportStatusMetadata>>;
  public seasonsMeritAdminExportPlanWithMissingIndividualValues(
    requestParameters?: SeasonsMeritAdminExportPlanWithMissingIndividualValuesParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'put',
      path: `/admin/api/v1/merit/season-plans/missing-individual-values`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { SeasonId: requestParameters?.seasonId }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsMeritAdminExportSeasonPopulations(
    requestParameters?: SeasonsMeritAdminExportSeasonPopulationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<ExportEmployeePopulationResultDto>;
  public seasonsMeritAdminExportSeasonPopulations(
    requestParameters?: SeasonsMeritAdminExportSeasonPopulationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<ExportEmployeePopulationResultDto>>;
  public seasonsMeritAdminExportSeasonPopulations(
    requestParameters?: SeasonsMeritAdminExportSeasonPopulationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<ExportEmployeePopulationResultDto>>;
  public seasonsMeritAdminExportSeasonPopulations(
    requestParameters?: SeasonsMeritAdminExportSeasonPopulationsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('seasonsMeritAdminExportSeasonPopulations', { seasonId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/merit/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/export-population`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsMeritAdminGetBudgetBuckets(
    requestParameters?: SeasonsMeritAdminGetBudgetBucketsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<BudgetBucketModel>;
  public seasonsMeritAdminGetBudgetBuckets(
    requestParameters?: SeasonsMeritAdminGetBudgetBucketsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<BudgetBucketModel>>;
  public seasonsMeritAdminGetBudgetBuckets(
    requestParameters?: SeasonsMeritAdminGetBudgetBucketsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<BudgetBucketModel>>;
  public seasonsMeritAdminGetBudgetBuckets(
    requestParameters?: SeasonsMeritAdminGetBudgetBucketsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('seasonsMeritAdminGetBudgetBuckets', { id });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/merit/budget-bucket/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsMeritAdminGetBudgetBucketsPlans(
    requestParameters?: SeasonsMeritAdminGetBudgetBucketsPlansParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Array<BudgetBucketModel>>;
  public seasonsMeritAdminGetBudgetBucketsPlans(
    requestParameters?: SeasonsMeritAdminGetBudgetBucketsPlansParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Array<BudgetBucketModel>>>;
  public seasonsMeritAdminGetBudgetBucketsPlans(
    requestParameters?: SeasonsMeritAdminGetBudgetBucketsPlansParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Array<BudgetBucketModel>>>;
  public seasonsMeritAdminGetBudgetBucketsPlans(
    requestParameters?: SeasonsMeritAdminGetBudgetBucketsPlansParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('seasonsMeritAdminGetBudgetBucketsPlans', { id });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/merit/plans/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/budget-buckets`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * Search for specific record entity by id
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsMeritAdminGetByIdRecords(
    requestParameters?: SeasonsMeritAdminGetByIdRecordsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<RecordModel>;
  public seasonsMeritAdminGetByIdRecords(
    requestParameters?: SeasonsMeritAdminGetByIdRecordsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<RecordModel>>;
  public seasonsMeritAdminGetByIdRecords(
    requestParameters?: SeasonsMeritAdminGetByIdRecordsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<RecordModel>>;
  public seasonsMeritAdminGetByIdRecords(
    requestParameters?: SeasonsMeritAdminGetByIdRecordsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const recordId = requestParameters?.recordId;
    this.checkRequired('seasonsMeritAdminGetByIdRecords', { recordId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/merit/records/${this.configuration.encodeParam({ name: 'recordId', value: recordId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsMeritAdminGetEmployeeSnapshots(
    requestParameters?: SeasonsMeritAdminGetEmployeeSnapshotsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<EmployeeSnapshotsEmployeeSnapshot>;
  public seasonsMeritAdminGetEmployeeSnapshots(
    requestParameters?: SeasonsMeritAdminGetEmployeeSnapshotsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<EmployeeSnapshotsEmployeeSnapshot>>;
  public seasonsMeritAdminGetEmployeeSnapshots(
    requestParameters?: SeasonsMeritAdminGetEmployeeSnapshotsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<EmployeeSnapshotsEmployeeSnapshot>>;
  public seasonsMeritAdminGetEmployeeSnapshots(
    requestParameters?: SeasonsMeritAdminGetEmployeeSnapshotsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const snapshotId = requestParameters?.snapshotId;
    this.checkRequired('seasonsMeritAdminGetEmployeeSnapshots', { snapshotId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/merit/employee-snapshots/${this.configuration.encodeParam({ name: 'snapshotId', value: snapshotId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsMeritAdminGetInformationFieldValuesOrganisationInformationSnapshots(
    requestParameters?: SeasonsMeritAdminGetInformationFieldValuesOrganisationInformationSnapshotsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfString>;
  public seasonsMeritAdminGetInformationFieldValuesOrganisationInformationSnapshots(
    requestParameters?: SeasonsMeritAdminGetInformationFieldValuesOrganisationInformationSnapshotsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfString>>;
  public seasonsMeritAdminGetInformationFieldValuesOrganisationInformationSnapshots(
    requestParameters?: SeasonsMeritAdminGetInformationFieldValuesOrganisationInformationSnapshotsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfString>>;
  public seasonsMeritAdminGetInformationFieldValuesOrganisationInformationSnapshots(
    requestParameters?: SeasonsMeritAdminGetInformationFieldValuesOrganisationInformationSnapshotsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('seasonsMeritAdminGetInformationFieldValuesOrganisationInformationSnapshots', { seasonId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/merit/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/snapshots/organisations/information/field-values`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        TargetProperty: requestParameters?.targetProperty,
        OrgCode: requestParameters?.orgCode,
        Page: requestParameters?.page,
        Size: requestParameters?.size
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsMeritAdminGetMembers(
    requestParameters?: SeasonsMeritAdminGetMembersParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<MemberModel>;
  public seasonsMeritAdminGetMembers(
    requestParameters?: SeasonsMeritAdminGetMembersParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<MemberModel>>;
  public seasonsMeritAdminGetMembers(
    requestParameters?: SeasonsMeritAdminGetMembersParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<MemberModel>>;
  public seasonsMeritAdminGetMembers(
    requestParameters?: SeasonsMeritAdminGetMembersParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('seasonsMeritAdminGetMembers', { id });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/merit/members/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsMeritAdminGetMySeasonRecordsSeasons(
    requestParameters?: SeasonsMeritAdminGetMySeasonRecordsSeasonsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfRecord>;
  public seasonsMeritAdminGetMySeasonRecordsSeasons(
    requestParameters?: SeasonsMeritAdminGetMySeasonRecordsSeasonsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfRecord>>;
  public seasonsMeritAdminGetMySeasonRecordsSeasons(
    requestParameters?: SeasonsMeritAdminGetMySeasonRecordsSeasonsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfRecord>>;
  public seasonsMeritAdminGetMySeasonRecordsSeasons(
    requestParameters?: SeasonsMeritAdminGetMySeasonRecordsSeasonsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('seasonsMeritAdminGetMySeasonRecordsSeasons', { id });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/merit/seasons/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/myrecords`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { memberId: requestParameters?.memberId, gid: requestParameters?.gid }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsMeritAdminGetOfSeasonPublicationSettings(
    requestParameters?: SeasonsMeritAdminGetOfSeasonPublicationSettingsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PublicationSettingsModel>;
  public seasonsMeritAdminGetOfSeasonPublicationSettings(
    requestParameters?: SeasonsMeritAdminGetOfSeasonPublicationSettingsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PublicationSettingsModel>>;
  public seasonsMeritAdminGetOfSeasonPublicationSettings(
    requestParameters?: SeasonsMeritAdminGetOfSeasonPublicationSettingsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PublicationSettingsModel>>;
  public seasonsMeritAdminGetOfSeasonPublicationSettings(
    requestParameters?: SeasonsMeritAdminGetOfSeasonPublicationSettingsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('seasonsMeritAdminGetOfSeasonPublicationSettings', { seasonId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/merit/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/publication-settings`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsMeritAdminGetOrganisationInformationSnapshots(
    requestParameters?: SeasonsMeritAdminGetOrganisationInformationSnapshotsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<OrganisationInformationSnapshotModel>;
  public seasonsMeritAdminGetOrganisationInformationSnapshots(
    requestParameters?: SeasonsMeritAdminGetOrganisationInformationSnapshotsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<OrganisationInformationSnapshotModel>>;
  public seasonsMeritAdminGetOrganisationInformationSnapshots(
    requestParameters?: SeasonsMeritAdminGetOrganisationInformationSnapshotsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<OrganisationInformationSnapshotModel>>;
  public seasonsMeritAdminGetOrganisationInformationSnapshots(
    requestParameters?: SeasonsMeritAdminGetOrganisationInformationSnapshotsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('seasonsMeritAdminGetOrganisationInformationSnapshots', { id, seasonId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/merit/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/snapshots/organisations/information/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsMeritAdminGetOrganisationSnapshots(
    requestParameters?: SeasonsMeritAdminGetOrganisationSnapshotsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<OrganisationSnapshotModel>;
  public seasonsMeritAdminGetOrganisationSnapshots(
    requestParameters?: SeasonsMeritAdminGetOrganisationSnapshotsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<OrganisationSnapshotModel>>;
  public seasonsMeritAdminGetOrganisationSnapshots(
    requestParameters?: SeasonsMeritAdminGetOrganisationSnapshotsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<OrganisationSnapshotModel>>;
  public seasonsMeritAdminGetOrganisationSnapshots(
    requestParameters?: SeasonsMeritAdminGetOrganisationSnapshotsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    const id = requestParameters?.id;
    this.checkRequired('seasonsMeritAdminGetOrganisationSnapshots', { seasonId, id });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/merit/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/snapshots/organisations/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsMeritAdminGetPlanPopulationPlans(
    requestParameters?: SeasonsMeritAdminGetPlanPopulationPlansParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfMember>;
  public seasonsMeritAdminGetPlanPopulationPlans(
    requestParameters?: SeasonsMeritAdminGetPlanPopulationPlansParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfMember>>;
  public seasonsMeritAdminGetPlanPopulationPlans(
    requestParameters?: SeasonsMeritAdminGetPlanPopulationPlansParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfMember>>;
  public seasonsMeritAdminGetPlanPopulationPlans(
    requestParameters?: SeasonsMeritAdminGetPlanPopulationPlansParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('seasonsMeritAdminGetPlanPopulationPlans', { id });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/merit/plans/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/members`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { Page: requestParameters?.page, Size: requestParameters?.size }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsMeritAdminGetPlanRecordsPlans(
    requestParameters?: SeasonsMeritAdminGetPlanRecordsPlansParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfRecord>;
  public seasonsMeritAdminGetPlanRecordsPlans(
    requestParameters?: SeasonsMeritAdminGetPlanRecordsPlansParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfRecord>>;
  public seasonsMeritAdminGetPlanRecordsPlans(
    requestParameters?: SeasonsMeritAdminGetPlanRecordsPlansParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfRecord>>;
  public seasonsMeritAdminGetPlanRecordsPlans(
    requestParameters?: SeasonsMeritAdminGetPlanRecordsPlansParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('seasonsMeritAdminGetPlanRecordsPlans', { id });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/merit/plans/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/records`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { Page: requestParameters?.page, Size: requestParameters?.size }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsMeritAdminGetPlanSettings(
    requestParameters?: SeasonsMeritAdminGetPlanSettingsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PlanSettingsModel>;
  public seasonsMeritAdminGetPlanSettings(
    requestParameters?: SeasonsMeritAdminGetPlanSettingsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PlanSettingsModel>>;
  public seasonsMeritAdminGetPlanSettings(
    requestParameters?: SeasonsMeritAdminGetPlanSettingsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PlanSettingsModel>>;
  public seasonsMeritAdminGetPlanSettings(
    requestParameters?: SeasonsMeritAdminGetPlanSettingsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const planId = requestParameters?.planId;
    this.checkRequired('seasonsMeritAdminGetPlanSettings', { planId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/merit/season-plans/${this.configuration.encodeParam({ name: 'planId', value: planId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/settings`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsMeritAdminGetPlans(
    requestParameters?: SeasonsMeritAdminGetPlansParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PlanModel>;
  public seasonsMeritAdminGetPlans(
    requestParameters?: SeasonsMeritAdminGetPlansParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PlanModel>>;
  public seasonsMeritAdminGetPlans(
    requestParameters?: SeasonsMeritAdminGetPlansParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PlanModel>>;
  public seasonsMeritAdminGetPlans(
    requestParameters?: SeasonsMeritAdminGetPlansParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('seasonsMeritAdminGetPlans', { id });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/merit/plans/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsMeritAdminGetPublicationSettings(
    requestParameters?: SeasonsMeritAdminGetPublicationSettingsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PublicationSettingsModel>;
  public seasonsMeritAdminGetPublicationSettings(
    requestParameters?: SeasonsMeritAdminGetPublicationSettingsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PublicationSettingsModel>>;
  public seasonsMeritAdminGetPublicationSettings(
    requestParameters?: SeasonsMeritAdminGetPublicationSettingsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PublicationSettingsModel>>;
  public seasonsMeritAdminGetPublicationSettings(
    requestParameters?: SeasonsMeritAdminGetPublicationSettingsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('seasonsMeritAdminGetPublicationSettings', { id, seasonId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/merit/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/publication-settings/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * Search for record models based on given query parameters
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsMeritAdminGetRecords(
    requestParameters?: SeasonsMeritAdminGetRecordsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfRecord>;
  public seasonsMeritAdminGetRecords(
    requestParameters?: SeasonsMeritAdminGetRecordsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfRecord>>;
  public seasonsMeritAdminGetRecords(
    requestParameters?: SeasonsMeritAdminGetRecordsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfRecord>>;
  public seasonsMeritAdminGetRecords(
    requestParameters?: SeasonsMeritAdminGetRecordsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('seasonsMeritAdminGetRecords', { seasonId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/merit/records/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        MemberId: requestParameters?.memberId,
        Gid: requestParameters?.gid,
        FirstName: requestParameters?.firstName,
        LastName: requestParameters?.lastName,
        Country: requestParameters?.country,
        Are: requestParameters?.are,
        OrgCode: requestParameters?.orgCode,
        State: requestParameters?.state,
        PlanName: requestParameters?.planName,
        StartDate: requestParameters?.startDate,
        EndDate: requestParameters?.endDate,
        AssignmentId: requestParameters?.assignmentId,
        IsDesignReady: requestParameters?.isDesignReady,
        LetterState: requestParameters?.letterState,
        PayoutState: requestParameters?.payoutState,
        Template: requestParameters?.template,
        Workflow: requestParameters?.workflow,
        SeasonId: requestParameters?.seasonId2,
        WorkflowInstanceState: requestParameters?.workflowInstanceState,
        LineManagerName: requestParameters?.lineManagerName,
        LineManagerGid: requestParameters?.lineManagerGid,
        LineManagerPositionClass: requestParameters?.lineManagerPositionClass,
        Page: requestParameters?.page,
        Size: requestParameters?.size,
        OrderBy: requestParameters?.orderBy,
        Property: requestParameters?.property
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsMeritAdminGetSeasonCommunicationSettings(
    requestParameters?: SeasonsMeritAdminGetSeasonCommunicationSettingsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<MeritCommunicationSettings>;
  public seasonsMeritAdminGetSeasonCommunicationSettings(
    requestParameters?: SeasonsMeritAdminGetSeasonCommunicationSettingsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<MeritCommunicationSettings>>;
  public seasonsMeritAdminGetSeasonCommunicationSettings(
    requestParameters?: SeasonsMeritAdminGetSeasonCommunicationSettingsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<MeritCommunicationSettings>>;
  public seasonsMeritAdminGetSeasonCommunicationSettings(
    requestParameters?: SeasonsMeritAdminGetSeasonCommunicationSettingsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('seasonsMeritAdminGetSeasonCommunicationSettings', { seasonId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/merit/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/communication-settings`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsMeritAdminGetSeasonOverviewForEmployeeMembers(
    requestParameters?: SeasonsMeritAdminGetSeasonOverviewForEmployeeMembersParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<EmployeeSeasonOverview>;
  public seasonsMeritAdminGetSeasonOverviewForEmployeeMembers(
    requestParameters?: SeasonsMeritAdminGetSeasonOverviewForEmployeeMembersParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<EmployeeSeasonOverview>>;
  public seasonsMeritAdminGetSeasonOverviewForEmployeeMembers(
    requestParameters?: SeasonsMeritAdminGetSeasonOverviewForEmployeeMembersParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<EmployeeSeasonOverview>>;
  public seasonsMeritAdminGetSeasonOverviewForEmployeeMembers(
    requestParameters?: SeasonsMeritAdminGetSeasonOverviewForEmployeeMembersParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/merit/members/overview`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { gid: requestParameters?.gid }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsMeritAdminGetSeasonRecordsSeasons(
    requestParameters?: SeasonsMeritAdminGetSeasonRecordsSeasonsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfRecord>;
  public seasonsMeritAdminGetSeasonRecordsSeasons(
    requestParameters?: SeasonsMeritAdminGetSeasonRecordsSeasonsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfRecord>>;
  public seasonsMeritAdminGetSeasonRecordsSeasons(
    requestParameters?: SeasonsMeritAdminGetSeasonRecordsSeasonsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfRecord>>;
  public seasonsMeritAdminGetSeasonRecordsSeasons(
    requestParameters?: SeasonsMeritAdminGetSeasonRecordsSeasonsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('seasonsMeritAdminGetSeasonRecordsSeasons', { id });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/merit/seasons/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/records`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        'Query.Id': requestParameters?.queryId,
        'Query.Gid': requestParameters?.queryGid,
        'Query.FirstName': requestParameters?.queryFirstName,
        'Query.LastName': requestParameters?.queryLastName,
        'Query.Country': requestParameters?.queryCountry,
        'Query.Are': requestParameters?.queryAre,
        'Query.OrgCode': requestParameters?.queryOrgCode,
        'Query.OrgClusterNodeName': requestParameters?.queryOrgClusterNodeName,
        'Query.State': requestParameters?.queryState,
        'Query.PlanName': requestParameters?.queryPlanName,
        'Query.StartDate': requestParameters?.queryStartDate,
        'Query.EndDate': requestParameters?.queryEndDate,
        'Query.AssignmentId': requestParameters?.queryAssignmentId,
        'Query.LetterType': requestParameters?.queryLetterType,
        'Query.TemplateType': requestParameters?.queryTemplateType,
        'Query.ProcessStates': requestParameters?.queryProcessStates,
        'Query.RecordCommunicationStates': requestParameters?.queryRecordCommunicationStates,
        'Query.Workflow': requestParameters?.queryWorkflow,
        'Query.Template': requestParameters?.queryTemplate,
        'Query.IsDesignReady': requestParameters?.queryIsDesignReady,
        'Query.PayoutDate': requestParameters?.queryPayoutDate,
        'Query.PayoutState': requestParameters?.queryPayoutState,
        'Query.LineManagerName': requestParameters?.queryLineManagerName,
        'Query.LineManagerGid': requestParameters?.queryLineManagerGid,
        'Query.SeasonId': requestParameters?.querySeasonId,
        'Query.WorkflowInstanceState': requestParameters?.queryWorkflowInstanceState,
        'Query.Multiplier': requestParameters?.queryMultiplier,
        'Query.OverallTargetAchievement': requestParameters?.queryOverallTargetAchievement,
        'Query.PayoutAmount': requestParameters?.queryPayoutAmount,
        'Query.PayoutCurrency': requestParameters?.queryPayoutCurrency,
        'Query.IppAchievementValue': requestParameters?.queryIppAchievementValue,
        'Query.IncentivePaymentType': requestParameters?.queryIncentivePaymentType,
        'Query.ContractStatus': requestParameters?.queryContractStatus,
        'Query.MeasurementDate': requestParameters?.queryMeasurementDate,
        'Query.MeritTitle': requestParameters?.queryMeritTitle,
        'Query.EquityTitle': requestParameters?.queryEquityTitle,
        'Query.EquitySubTitle': requestParameters?.queryEquitySubTitle,
        'Query.ManuallyChanged': requestParameters?.queryManuallyChanged,
        'Query.NewHire': requestParameters?.queryNewHire,
        'Query.Promotion': requestParameters?.queryPromotion,
        'Query.Termination': requestParameters?.queryTermination,
        'Query.PopulationChange': requestParameters?.queryPopulationChange,
        'Query.LineManagerFirstName': requestParameters?.queryLineManagerFirstName,
        'Query.LineManagerLastName': requestParameters?.queryLineManagerLastName,
        'Query.CompanyManagerFirstName': requestParameters?.queryCompanyManagerFirstName,
        'Query.CompanyManagerGid': requestParameters?.queryCompanyManagerGid,
        'Query.CompanyManagerLastName': requestParameters?.queryCompanyManagerLastName,
        'Query.TemplateName': requestParameters?.queryTemplateName,
        'Query.WorkflowType': requestParameters?.queryWorkflowType,
        'Query.AutoApprove': requestParameters?.queryAutoApprove,
        'Query.ApprovalRequired': requestParameters?.queryApprovalRequired,
        'Query.LetterState': requestParameters?.queryLetterState,
        'Query.ProcessState': requestParameters?.queryProcessState,
        'Query.ExportState': requestParameters?.queryExportState,
        'Query.PayrollState': requestParameters?.queryPayrollState,
        'Query.MeritRelevancy': requestParameters?.queryMeritRelevancy,
        'Query.ApprovedByCompanyManager': requestParameters?.queryApprovedByCompanyManager,
        'Query.AllocationWorkflowType': requestParameters?.queryAllocationWorkflowType,
        'Query.ReadyToPayroll': requestParameters?.queryReadyToPayroll,
        'Query.EquityRelevancy': requestParameters?.queryEquityRelevancy,
        'Query.HasOtpIncrease': requestParameters?.queryHasOtpIncrease,
        'Query.IsOtpOnly': requestParameters?.queryIsOtpOnly,
        'Query.PlanTitle': requestParameters?.queryPlanTitle,
        'Query.LocalCurrency': requestParameters?.queryLocalCurrency,
        'Query.ProposalAmount': requestParameters?.queryProposalAmount,
        'Query.ProposalAmountInEuro': requestParameters?.queryProposalAmountInEuro,
        'Query.ProposalDate': requestParameters?.queryProposalDate,
        'Query.ProposalState': requestParameters?.queryProposalState,
        'Query.SpecialPaymentReason': requestParameters?.querySpecialPaymentReason,
        'Query.SpecialPaymentCompensationType': requestParameters?.querySpecialPaymentCompensationType,
        'Query.TemplateLetterName': requestParameters?.queryTemplateLetterName,
        'Paging.Page': requestParameters?.pagingPage,
        'Paging.Size': requestParameters?.pagingSize,
        'Sorting.OrderBy': requestParameters?.sortingOrderBy,
        'Sorting.Property': requestParameters?.sortingProperty
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsMeritAdminGetSeasonSettings(
    requestParameters?: SeasonsMeritAdminGetSeasonSettingsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<SeasonSettingsModel>;
  public seasonsMeritAdminGetSeasonSettings(
    requestParameters?: SeasonsMeritAdminGetSeasonSettingsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<SeasonSettingsModel>>;
  public seasonsMeritAdminGetSeasonSettings(
    requestParameters?: SeasonsMeritAdminGetSeasonSettingsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<SeasonSettingsModel>>;
  public seasonsMeritAdminGetSeasonSettings(
    requestParameters?: SeasonsMeritAdminGetSeasonSettingsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('seasonsMeritAdminGetSeasonSettings', { seasonId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/merit/settings/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsMeritAdminGetSeasons(
    requestParameters?: SeasonsMeritAdminGetSeasonsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<SeasonModel>;
  public seasonsMeritAdminGetSeasons(
    requestParameters?: SeasonsMeritAdminGetSeasonsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<SeasonModel>>;
  public seasonsMeritAdminGetSeasons(
    requestParameters?: SeasonsMeritAdminGetSeasonsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<SeasonModel>>;
  public seasonsMeritAdminGetSeasons(
    requestParameters?: SeasonsMeritAdminGetSeasonsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('seasonsMeritAdminGetSeasons', { id });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/merit/seasons/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsMeritAdminGetSimulation(
    requestParameters?: SeasonsMeritAdminGetSimulationParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Array<PositionEvaluationSimulationModel>>;
  public seasonsMeritAdminGetSimulation(
    requestParameters?: SeasonsMeritAdminGetSimulationParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Array<PositionEvaluationSimulationModel>>>;
  public seasonsMeritAdminGetSimulation(
    requestParameters?: SeasonsMeritAdminGetSimulationParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Array<PositionEvaluationSimulationModel>>>;
  public seasonsMeritAdminGetSimulation(
    requestParameters?: SeasonsMeritAdminGetSimulationParams,
    ...args: RequestArgs
  ): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    this.checkRequired('seasonsMeritAdminGetSimulation', { simulationId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/merit/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsMeritAdminGetSnapshotSeasons(
    requestParameters?: SeasonsMeritAdminGetSnapshotSeasonsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Snapshot>;
  public seasonsMeritAdminGetSnapshotSeasons(
    requestParameters?: SeasonsMeritAdminGetSnapshotSeasonsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Snapshot>>;
  public seasonsMeritAdminGetSnapshotSeasons(
    requestParameters?: SeasonsMeritAdminGetSnapshotSeasonsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Snapshot>>;
  public seasonsMeritAdminGetSnapshotSeasons(
    requestParameters?: SeasonsMeritAdminGetSnapshotSeasonsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    const employeeId = requestParameters?.employeeId;
    this.checkRequired('seasonsMeritAdminGetSnapshotSeasons', { id, employeeId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/merit/seasons/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/snapshots/${this.configuration.encodeParam({ name: 'employeeId', value: employeeId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsMeritAdminGetTreeOrganisationSnapshots(
    requestParameters?: SeasonsMeritAdminGetTreeOrganisationSnapshotsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Array<OrganisationSnapshotTreeItem>>;
  public seasonsMeritAdminGetTreeOrganisationSnapshots(
    requestParameters?: SeasonsMeritAdminGetTreeOrganisationSnapshotsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Array<OrganisationSnapshotTreeItem>>>;
  public seasonsMeritAdminGetTreeOrganisationSnapshots(
    requestParameters?: SeasonsMeritAdminGetTreeOrganisationSnapshotsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Array<OrganisationSnapshotTreeItem>>>;
  public seasonsMeritAdminGetTreeOrganisationSnapshots(
    requestParameters?: SeasonsMeritAdminGetTreeOrganisationSnapshotsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('seasonsMeritAdminGetTreeOrganisationSnapshots', { seasonId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/merit/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/snapshots/organisations/tree`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { parentOrgCode: requestParameters?.parentOrgCode }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsMeritAdminPartialUpdateEmployeeSnapshots(
    requestParameters?: SeasonsMeritAdminPartialUpdateEmployeeSnapshotsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<EmployeeSnapshotsEmployeeSnapshot>;
  public seasonsMeritAdminPartialUpdateEmployeeSnapshots(
    requestParameters?: SeasonsMeritAdminPartialUpdateEmployeeSnapshotsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<EmployeeSnapshotsEmployeeSnapshot>>;
  public seasonsMeritAdminPartialUpdateEmployeeSnapshots(
    requestParameters?: SeasonsMeritAdminPartialUpdateEmployeeSnapshotsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<EmployeeSnapshotsEmployeeSnapshot>>;
  public seasonsMeritAdminPartialUpdateEmployeeSnapshots(
    requestParameters?: SeasonsMeritAdminPartialUpdateEmployeeSnapshotsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const snapshotId = requestParameters?.snapshotId;
    this.checkRequired('seasonsMeritAdminPartialUpdateEmployeeSnapshots', { snapshotId });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/admin/api/v1/merit/employee-snapshots/${this.configuration.encodeParam({ name: 'snapshotId', value: snapshotId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.updateEmployeeSnapshotPartial,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsMeritAdminPrePublishSimulationPublications(
    requestParameters?: SeasonsMeritAdminPrePublishSimulationPublicationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfSimulationPublishMetadata>;
  public seasonsMeritAdminPrePublishSimulationPublications(
    requestParameters?: SeasonsMeritAdminPrePublishSimulationPublicationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfSimulationPublishMetadata>>;
  public seasonsMeritAdminPrePublishSimulationPublications(
    requestParameters?: SeasonsMeritAdminPrePublishSimulationPublicationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfSimulationPublishMetadata>>;
  public seasonsMeritAdminPrePublishSimulationPublications(
    requestParameters?: SeasonsMeritAdminPrePublishSimulationPublicationsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    this.checkRequired('seasonsMeritAdminPrePublishSimulationPublications', { simulationId });
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v1/merit/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/pre-publish`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        PositionName: requestParameters?.positionName,
        OrgCode: requestParameters?.orgCode,
        OrgCodeStartsWith: requestParameters?.orgCodeStartsWith,
        OrgLevel: requestParameters?.orgLevel,
        OrgSize: requestParameters?.orgSize,
        MercerJobCode: requestParameters?.mercerJobCode,
        PositionClass: requestParameters?.positionClass,
        NewPositionClass: requestParameters?.newPositionClass,
        OriginalProposedPositionClass: requestParameters?.originalProposedPositionClass,
        PositionType: requestParameters?.positionType,
        CountryIsoCode: requestParameters?.countryIsoCode,
        IncumbentGid: requestParameters?.incumbentGid,
        IncumbentFirstName: requestParameters?.incumbentFirstName,
        IncumbentLastName: requestParameters?.incumbentLastName,
        IncumbentCountryPlaceOfAction: requestParameters?.incumbentCountryPlaceOfAction,
        ValidationManagerId: requestParameters?.validationManagerId,
        ValidationManagerGid: requestParameters?.validationManagerGid,
        ValidationManagerFirstName: requestParameters?.validationManagerFirstName,
        ValidationManagerLastName: requestParameters?.validationManagerLastName,
        ValidationState: requestParameters?.validationState,
        PlacementState: requestParameters?.placementState,
        NewHireState: requestParameters?.newHireState,
        IsLocked: requestParameters?.isLocked,
        MercerJobFamily: requestParameters?.mercerJobFamily,
        MercerJobSpecialization: requestParameters?.mercerJobSpecialization,
        MercerJobSubFamily: requestParameters?.mercerJobSubFamily,
        IncumbentAre: requestParameters?.incumbentAre,
        Tag: requestParameters?.tag,
        WasPromoted: requestParameters?.wasPromoted,
        IsTransferred: requestParameters?.isTransferred
      },
      body: requestParameters?.simulationPublicationsPublishSimulation,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsMeritAdminPublishSimulationPublications(
    requestParameters?: SeasonsMeritAdminPublishSimulationPublicationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfSimulationPublishMetadata>;
  public seasonsMeritAdminPublishSimulationPublications(
    requestParameters?: SeasonsMeritAdminPublishSimulationPublicationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfSimulationPublishMetadata>>;
  public seasonsMeritAdminPublishSimulationPublications(
    requestParameters?: SeasonsMeritAdminPublishSimulationPublicationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfSimulationPublishMetadata>>;
  public seasonsMeritAdminPublishSimulationPublications(
    requestParameters?: SeasonsMeritAdminPublishSimulationPublicationsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    this.checkRequired('seasonsMeritAdminPublishSimulationPublications', { simulationId });
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v1/merit/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/publish`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        'Query.PositionName': requestParameters?.queryPositionName,
        'Query.OrgCode': requestParameters?.queryOrgCode,
        'Query.OrgCodeStartsWith': requestParameters?.queryOrgCodeStartsWith,
        'Query.OrgLevel': requestParameters?.queryOrgLevel,
        'Query.OrgSize': requestParameters?.queryOrgSize,
        'Query.MercerJobCode': requestParameters?.queryMercerJobCode,
        'Query.PositionClass': requestParameters?.queryPositionClass,
        'Query.NewPositionClass': requestParameters?.queryNewPositionClass,
        'Query.OriginalProposedPositionClass': requestParameters?.queryOriginalProposedPositionClass,
        'Query.PositionType': requestParameters?.queryPositionType,
        'Query.CountryIsoCode': requestParameters?.queryCountryIsoCode,
        'Query.IncumbentGid': requestParameters?.queryIncumbentGid,
        'Query.IncumbentFirstName': requestParameters?.queryIncumbentFirstName,
        'Query.IncumbentLastName': requestParameters?.queryIncumbentLastName,
        'Query.IncumbentCountryPlaceOfAction': requestParameters?.queryIncumbentCountryPlaceOfAction,
        'Query.ValidationManagerId': requestParameters?.queryValidationManagerId,
        'Query.ValidationManagerGid': requestParameters?.queryValidationManagerGid,
        'Query.ValidationManagerFirstName': requestParameters?.queryValidationManagerFirstName,
        'Query.ValidationManagerLastName': requestParameters?.queryValidationManagerLastName,
        'Query.ValidationState': requestParameters?.queryValidationState,
        'Query.PlacementState': requestParameters?.queryPlacementState,
        'Query.NewHireState': requestParameters?.queryNewHireState,
        'Query.IsLocked': requestParameters?.queryIsLocked,
        'Query.MercerJobFamily': requestParameters?.queryMercerJobFamily,
        'Query.MercerJobSpecialization': requestParameters?.queryMercerJobSpecialization,
        'Query.MercerJobSubFamily': requestParameters?.queryMercerJobSubFamily,
        'Query.IncumbentAre': requestParameters?.queryIncumbentAre,
        'Query.Tag': requestParameters?.queryTag,
        'Query.WasPromoted': requestParameters?.queryWasPromoted,
        'Query.IsTransferred': requestParameters?.queryIsTransferred
      },
      body: requestParameters?.simulationPublicationsPublishSimulation,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsMeritAdminQueryCandidatePools(
    requestParameters?: SeasonsMeritAdminQueryCandidatePoolsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Array<CandidatePoolModel>>;
  public seasonsMeritAdminQueryCandidatePools(
    requestParameters?: SeasonsMeritAdminQueryCandidatePoolsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Array<CandidatePoolModel>>>;
  public seasonsMeritAdminQueryCandidatePools(
    requestParameters?: SeasonsMeritAdminQueryCandidatePoolsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Array<CandidatePoolModel>>>;
  public seasonsMeritAdminQueryCandidatePools(
    requestParameters?: SeasonsMeritAdminQueryCandidatePoolsParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/merit/candidate-pools`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { seasonId: requestParameters?.seasonId }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsMeritAdminQueryEmployeeCandidates(
    requestParameters?: SeasonsMeritAdminQueryEmployeeCandidatesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfPositionEvaluationCandidate>;
  public seasonsMeritAdminQueryEmployeeCandidates(
    requestParameters?: SeasonsMeritAdminQueryEmployeeCandidatesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfPositionEvaluationCandidate>>;
  public seasonsMeritAdminQueryEmployeeCandidates(
    requestParameters?: SeasonsMeritAdminQueryEmployeeCandidatesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfPositionEvaluationCandidate>>;
  public seasonsMeritAdminQueryEmployeeCandidates(
    requestParameters?: SeasonsMeritAdminQueryEmployeeCandidatesParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/merit/employee-candidates`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        SeasonId: requestParameters?.seasonId,
        'Query.Gid': requestParameters?.queryGid,
        'Query.Firstname': requestParameters?.queryFirstname,
        'Query.Lastname': requestParameters?.queryLastname,
        'Query.PAOrgCode': requestParameters?.queryPAOrgCode,
        'Query.CandidatePoolTitle': requestParameters?.queryCandidatePoolTitle,
        'Query.OrgCode': requestParameters?.queryOrgCode,
        'Query.Gender': requestParameters?.queryGender,
        'Query.OrgLevel': requestParameters?.queryOrgLevel,
        'Query.MercerPositionClass': requestParameters?.queryMercerPositionClass,
        'Query.IsPlaced': requestParameters?.queryIsPlaced,
        'Query.IsShortlisted': requestParameters?.queryIsShortlisted,
        'Sorting.OrderBy': requestParameters?.sortingOrderBy,
        'Sorting.Property': requestParameters?.sortingProperty,
        'Paging.Page': requestParameters?.pagingPage,
        'Paging.Size': requestParameters?.pagingSize
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsMeritAdminQueryEmployeeSnapshots(
    requestParameters?: SeasonsMeritAdminQueryEmployeeSnapshotsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfEmployeeSnapshotsEmployeeSnapshot>;
  public seasonsMeritAdminQueryEmployeeSnapshots(
    requestParameters?: SeasonsMeritAdminQueryEmployeeSnapshotsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfEmployeeSnapshotsEmployeeSnapshot>>;
  public seasonsMeritAdminQueryEmployeeSnapshots(
    requestParameters?: SeasonsMeritAdminQueryEmployeeSnapshotsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfEmployeeSnapshotsEmployeeSnapshot>>;
  public seasonsMeritAdminQueryEmployeeSnapshots(
    requestParameters?: SeasonsMeritAdminQueryEmployeeSnapshotsParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/merit/employee-snapshots`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { Page: requestParameters?.page, Size: requestParameters?.size }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsMeritAdminQueryFieldValuesEmployeeCandidates(
    requestParameters?: SeasonsMeritAdminQueryFieldValuesEmployeeCandidatesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfString>;
  public seasonsMeritAdminQueryFieldValuesEmployeeCandidates(
    requestParameters?: SeasonsMeritAdminQueryFieldValuesEmployeeCandidatesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfString>>;
  public seasonsMeritAdminQueryFieldValuesEmployeeCandidates(
    requestParameters?: SeasonsMeritAdminQueryFieldValuesEmployeeCandidatesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfString>>;
  public seasonsMeritAdminQueryFieldValuesEmployeeCandidates(
    requestParameters?: SeasonsMeritAdminQueryFieldValuesEmployeeCandidatesParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/merit/employee-candidates/field-values`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        TargetProperty: requestParameters?.targetProperty,
        SeasonId: requestParameters?.seasonId,
        'Paging.Page': requestParameters?.pagingPage,
        'Paging.Size': requestParameters?.pagingSize,
        Gid: requestParameters?.gid,
        Firstname: requestParameters?.firstname,
        Lastname: requestParameters?.lastname,
        PAOrgCode: requestParameters?.pAOrgCode,
        CandidatePoolTitle: requestParameters?.candidatePoolTitle,
        OrgCode: requestParameters?.orgCode,
        Gender: requestParameters?.gender,
        OrgLevel: requestParameters?.orgLevel,
        MercerPositionClass: requestParameters?.mercerPositionClass,
        IsPlaced: requestParameters?.isPlaced,
        IsShortlisted: requestParameters?.isShortlisted
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsMeritAdminQueryFieldValuesOrganisationSnapshots(
    requestParameters?: SeasonsMeritAdminQueryFieldValuesOrganisationSnapshotsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfString>;
  public seasonsMeritAdminQueryFieldValuesOrganisationSnapshots(
    requestParameters?: SeasonsMeritAdminQueryFieldValuesOrganisationSnapshotsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfString>>;
  public seasonsMeritAdminQueryFieldValuesOrganisationSnapshots(
    requestParameters?: SeasonsMeritAdminQueryFieldValuesOrganisationSnapshotsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfString>>;
  public seasonsMeritAdminQueryFieldValuesOrganisationSnapshots(
    requestParameters?: SeasonsMeritAdminQueryFieldValuesOrganisationSnapshotsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('seasonsMeritAdminQueryFieldValuesOrganisationSnapshots', { seasonId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/merit/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/snapshots/organisations/field-values`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        TargetProperty: requestParameters?.targetProperty,
        OrgCode: requestParameters?.orgCode,
        Page: requestParameters?.page,
        Size: requestParameters?.size
      }
    });
  }

  /**
   * Get possible field values for given record property
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsMeritAdminQueryFieldValuesRecords(
    requestParameters?: SeasonsMeritAdminQueryFieldValuesRecordsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfString>;
  public seasonsMeritAdminQueryFieldValuesRecords(
    requestParameters?: SeasonsMeritAdminQueryFieldValuesRecordsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfString>>;
  public seasonsMeritAdminQueryFieldValuesRecords(
    requestParameters?: SeasonsMeritAdminQueryFieldValuesRecordsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfString>>;
  public seasonsMeritAdminQueryFieldValuesRecords(
    requestParameters?: SeasonsMeritAdminQueryFieldValuesRecordsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const targetProperty = requestParameters?.targetProperty;
    this.checkRequired('seasonsMeritAdminQueryFieldValuesRecords', { targetProperty });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/merit/records/field-values`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        TargetProperty: targetProperty,
        MemberId: requestParameters?.memberId,
        Gid: requestParameters?.gid,
        FirstName: requestParameters?.firstName,
        LastName: requestParameters?.lastName,
        Country: requestParameters?.country,
        Are: requestParameters?.are,
        OrgCode: requestParameters?.orgCode,
        State: requestParameters?.state,
        PlanName: requestParameters?.planName,
        StartDate: requestParameters?.startDate,
        EndDate: requestParameters?.endDate,
        AssignmentId: requestParameters?.assignmentId,
        IsDesignReady: requestParameters?.isDesignReady,
        LetterState: requestParameters?.letterState,
        PayoutState: requestParameters?.payoutState,
        Template: requestParameters?.template,
        Workflow: requestParameters?.workflow,
        SeasonId: requestParameters?.seasonId,
        WorkflowInstanceState: requestParameters?.workflowInstanceState,
        LineManagerName: requestParameters?.lineManagerName,
        LineManagerGid: requestParameters?.lineManagerGid,
        LineManagerPositionClass: requestParameters?.lineManagerPositionClass,
        Page: requestParameters?.page,
        Size: requestParameters?.size
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsMeritAdminQueryInformationOrganisationInformationSnapshots(
    requestParameters?: SeasonsMeritAdminQueryInformationOrganisationInformationSnapshotsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfOrganisationInformationSnapshot>;
  public seasonsMeritAdminQueryInformationOrganisationInformationSnapshots(
    requestParameters?: SeasonsMeritAdminQueryInformationOrganisationInformationSnapshotsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfOrganisationInformationSnapshot>>;
  public seasonsMeritAdminQueryInformationOrganisationInformationSnapshots(
    requestParameters?: SeasonsMeritAdminQueryInformationOrganisationInformationSnapshotsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfOrganisationInformationSnapshot>>;
  public seasonsMeritAdminQueryInformationOrganisationInformationSnapshots(
    requestParameters?: SeasonsMeritAdminQueryInformationOrganisationInformationSnapshotsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('seasonsMeritAdminQueryInformationOrganisationInformationSnapshots', { seasonId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/merit/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/snapshots/organisations/information`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        OrgCode: requestParameters?.orgCode,
        OrgName: requestParameters?.orgName,
        OrgSize: requestParameters?.orgSize,
        Revenue: requestParameters?.revenue,
        HeadCount: requestParameters?.headCount,
        RevenueOrgSize: requestParameters?.revenueOrgSize,
        HeadCountOrgSize: requestParameters?.headCountOrgSize,
        ShowOrganisationsWithoutOrgInfos: requestParameters?.showOrganisationsWithoutOrgInfos,
        Page: requestParameters?.page,
        Size: requestParameters?.size,
        OrderBy: requestParameters?.orderBy,
        Property: requestParameters?.property
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsMeritAdminQueryInformationVisibilitySettings(
    requestParameters?: SeasonsMeritAdminQueryInformationVisibilitySettingsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfMeritInformationVisibilitySettings>;
  public seasonsMeritAdminQueryInformationVisibilitySettings(
    requestParameters?: SeasonsMeritAdminQueryInformationVisibilitySettingsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfMeritInformationVisibilitySettings>>;
  public seasonsMeritAdminQueryInformationVisibilitySettings(
    requestParameters?: SeasonsMeritAdminQueryInformationVisibilitySettingsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfMeritInformationVisibilitySettings>>;
  public seasonsMeritAdminQueryInformationVisibilitySettings(
    requestParameters?: SeasonsMeritAdminQueryInformationVisibilitySettingsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    this.checkRequired('seasonsMeritAdminQueryInformationVisibilitySettings', { simulationId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/merit/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/settings/information-visibility`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        'Query.TargetProperty': requestParameters?.queryTargetProperty,
        'Query.TargetTypeString': requestParameters?.queryTargetTypeString,
        'Query.SimulationId': requestParameters?.querySimulationId,
        'Query.Priority': requestParameters?.queryPriority,
        'Query.Title': requestParameters?.queryTitle,
        'Query.AffectedCount': requestParameters?.queryAffectedCount,
        'Query.Type': requestParameters?.queryType,
        'Paging.Page': requestParameters?.pagingPage,
        'Paging.Size': requestParameters?.pagingSize,
        'Sorting.OrderBy': requestParameters?.sortingOrderBy,
        'Sorting.Property': requestParameters?.sortingProperty
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsMeritAdminQueryMembers(
    requestParameters?: SeasonsMeritAdminQueryMembersParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfMember>;
  public seasonsMeritAdminQueryMembers(
    requestParameters?: SeasonsMeritAdminQueryMembersParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfMember>>;
  public seasonsMeritAdminQueryMembers(
    requestParameters?: SeasonsMeritAdminQueryMembersParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfMember>>;
  public seasonsMeritAdminQueryMembers(
    requestParameters?: SeasonsMeritAdminQueryMembersParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/merit/members`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { Page: requestParameters?.page, Size: requestParameters?.size }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsMeritAdminQueryOrganisationSnapshots(
    requestParameters?: SeasonsMeritAdminQueryOrganisationSnapshotsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfOrganisationSnapshot>;
  public seasonsMeritAdminQueryOrganisationSnapshots(
    requestParameters?: SeasonsMeritAdminQueryOrganisationSnapshotsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfOrganisationSnapshot>>;
  public seasonsMeritAdminQueryOrganisationSnapshots(
    requestParameters?: SeasonsMeritAdminQueryOrganisationSnapshotsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfOrganisationSnapshot>>;
  public seasonsMeritAdminQueryOrganisationSnapshots(
    requestParameters?: SeasonsMeritAdminQueryOrganisationSnapshotsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('seasonsMeritAdminQueryOrganisationSnapshots', { seasonId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/merit/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/snapshots/organisations`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        'Query.SeasonId': requestParameters?.querySeasonId,
        'Query.OrganisationId': requestParameters?.queryOrganisationId,
        'Query.OrgCode': requestParameters?.queryOrgCode,
        'Query.OrgLevel': requestParameters?.queryOrgLevel,
        'Query.ParentOrgCode': requestParameters?.queryParentOrgCode,
        'Query.HeadId': requestParameters?.queryHeadId,
        'Query.HeadGid': requestParameters?.queryHeadGid,
        'Query.HeadName': requestParameters?.queryHeadName,
        'Query.PositionName': requestParameters?.queryPositionName,
        'Query.AdditionalLineOne': requestParameters?.queryAdditionalLineOne,
        'Query.AdditionalLineTwo': requestParameters?.queryAdditionalLineTwo,
        'Query.AdditionalLineThree': requestParameters?.queryAdditionalLineThree,
        'Query.AdditionalLineFour': requestParameters?.queryAdditionalLineFour,
        'Query.OrgName': requestParameters?.queryOrgName,
        'Query.OrgType': requestParameters?.queryOrgType,
        'Query.OrgLevelA': requestParameters?.queryOrgLevelA,
        'Query.OrgLevelB': requestParameters?.queryOrgLevelB,
        'Query.OrgLevelC': requestParameters?.queryOrgLevelC,
        'Query.OrgLevelD': requestParameters?.queryOrgLevelD,
        'Query.NumberOfEmployees': requestParameters?.queryNumberOfEmployees,
        'Query.HeadFirstname': requestParameters?.queryHeadFirstname,
        'Query.HeadLastname': requestParameters?.queryHeadLastname,
        'Query.HeadPAOrgCode': requestParameters?.queryHeadPAOrgCode,
        'Query.HeadPlaceOfAction': requestParameters?.queryHeadPlaceOfAction,
        'Query.HeadMercerJobCode': requestParameters?.queryHeadMercerJobCode,
        'Query.HeadMercerPositionClass': requestParameters?.queryHeadMercerPositionClass,
        'Query.HeadManagementGroup': requestParameters?.queryHeadManagementGroup,
        'Query.OrgSize': requestParameters?.queryOrgSize,
        'Query.Revenue': requestParameters?.queryRevenue,
        'Query.HeadCount': requestParameters?.queryHeadCount,
        'Query.RevenueOrgSize': requestParameters?.queryRevenueOrgSize,
        'Query.HeadCountOrgSize': requestParameters?.queryHeadCountOrgSize,
        'Query.ShowOrganisationsWithoutOrgInfos': requestParameters?.queryShowOrganisationsWithoutOrgInfos,
        'Paging.Page': requestParameters?.pagingPage,
        'Paging.Size': requestParameters?.pagingSize,
        'Sorting.OrderBy': requestParameters?.sortingOrderBy,
        'Sorting.Property': requestParameters?.sortingProperty
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsMeritAdminQueryOrganisationSnapshotsAndEmployeeSnapshotsSnapshots(
    requestParameters?: SeasonsMeritAdminQueryOrganisationSnapshotsAndEmployeeSnapshotsSnapshotsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfSnapshot>;
  public seasonsMeritAdminQueryOrganisationSnapshotsAndEmployeeSnapshotsSnapshots(
    requestParameters?: SeasonsMeritAdminQueryOrganisationSnapshotsAndEmployeeSnapshotsSnapshotsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfSnapshot>>;
  public seasonsMeritAdminQueryOrganisationSnapshotsAndEmployeeSnapshotsSnapshots(
    requestParameters?: SeasonsMeritAdminQueryOrganisationSnapshotsAndEmployeeSnapshotsSnapshotsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfSnapshot>>;
  public seasonsMeritAdminQueryOrganisationSnapshotsAndEmployeeSnapshotsSnapshots(
    requestParameters?: SeasonsMeritAdminQueryOrganisationSnapshotsAndEmployeeSnapshotsSnapshotsParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/merit/snapshots/employees`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        SeasonId: requestParameters?.seasonId,
        MeritSeasonId: requestParameters?.meritSeasonId,
        Search: requestParameters?.search,
        Directs: requestParameters?.directs,
        'Paging.Page': requestParameters?.pagingPage,
        'Paging.Size': requestParameters?.pagingSize,
        'Sorting.OrderBy': requestParameters?.sortingOrderBy,
        'Sorting.Property': requestParameters?.sortingProperty,
        impersonatedEmployee: requestParameters?.impersonatedEmployee
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsMeritAdminQueryParentsOrganisationSnapshots(
    requestParameters?: SeasonsMeritAdminQueryParentsOrganisationSnapshotsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<OrganisationSnapshotModel>;
  public seasonsMeritAdminQueryParentsOrganisationSnapshots(
    requestParameters?: SeasonsMeritAdminQueryParentsOrganisationSnapshotsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<OrganisationSnapshotModel>>;
  public seasonsMeritAdminQueryParentsOrganisationSnapshots(
    requestParameters?: SeasonsMeritAdminQueryParentsOrganisationSnapshotsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<OrganisationSnapshotModel>>;
  public seasonsMeritAdminQueryParentsOrganisationSnapshots(
    requestParameters?: SeasonsMeritAdminQueryParentsOrganisationSnapshotsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    const seasonId2 = requestParameters?.seasonId2;
    this.checkRequired('seasonsMeritAdminQueryParentsOrganisationSnapshots', { seasonId, seasonId2 });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/merit/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/snapshots/organisations/parents`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { SeasonId: seasonId2, 'Query.OrgCode': requestParameters?.queryOrgCode }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsMeritAdminQueryPlanWithMissingIndividualValues(
    requestParameters?: SeasonsMeritAdminQueryPlanWithMissingIndividualValuesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfPlanWithMissingIndividualValues>;
  public seasonsMeritAdminQueryPlanWithMissingIndividualValues(
    requestParameters?: SeasonsMeritAdminQueryPlanWithMissingIndividualValuesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfPlanWithMissingIndividualValues>>;
  public seasonsMeritAdminQueryPlanWithMissingIndividualValues(
    requestParameters?: SeasonsMeritAdminQueryPlanWithMissingIndividualValuesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfPlanWithMissingIndividualValues>>;
  public seasonsMeritAdminQueryPlanWithMissingIndividualValues(
    requestParameters?: SeasonsMeritAdminQueryPlanWithMissingIndividualValuesParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/merit/season-plans/missing-individual-values`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        SeasonId: requestParameters?.seasonId,
        'Query.KpiId': requestParameters?.queryKpiId,
        'Query.AssignmentId': requestParameters?.queryAssignmentId,
        'Query.OrgClusterNodeName': requestParameters?.queryOrgClusterNodeName,
        'Query.Gid': requestParameters?.queryGid,
        'Query.Lastname': requestParameters?.queryLastname,
        'Query.Firstname': requestParameters?.queryFirstname,
        'Query.Country': requestParameters?.queryCountry,
        'Query.OrgCode': requestParameters?.queryOrgCode,
        'Query.RecordStartdate': requestParameters?.queryRecordStartdate,
        'Query.PlanName': requestParameters?.queryPlanName,
        'Paging.Page': requestParameters?.pagingPage,
        'Paging.Size': requestParameters?.pagingSize,
        'Sorting.OrderBy': requestParameters?.sortingOrderBy,
        'Sorting.Property': requestParameters?.sortingProperty
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsMeritAdminQueryPlans(
    requestParameters?: SeasonsMeritAdminQueryPlansParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfPlan>;
  public seasonsMeritAdminQueryPlans(
    requestParameters?: SeasonsMeritAdminQueryPlansParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfPlan>>;
  public seasonsMeritAdminQueryPlans(
    requestParameters?: SeasonsMeritAdminQueryPlansParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfPlan>>;
  public seasonsMeritAdminQueryPlans(
    requestParameters?: SeasonsMeritAdminQueryPlansParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/merit/plans`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { Page: requestParameters?.page, Size: requestParameters?.size, seasonId: requestParameters?.seasonId }
    });
  }

  /**
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsMeritAdminQueryPossibilitiesBudgetBuckets(
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Array<BucketComponentsPossibilities>>;
  public seasonsMeritAdminQueryPossibilitiesBudgetBuckets(
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Array<BucketComponentsPossibilities>>>;
  public seasonsMeritAdminQueryPossibilitiesBudgetBuckets(
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Array<BucketComponentsPossibilities>>>;
  public seasonsMeritAdminQueryPossibilitiesBudgetBuckets(...args: RequestArgs): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/merit/budget-bucket/component-settings`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsMeritAdminQuerySeasons(
    requestParameters?: SeasonsMeritAdminQuerySeasonsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfSeason>;
  public seasonsMeritAdminQuerySeasons(
    requestParameters?: SeasonsMeritAdminQuerySeasonsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfSeason>>;
  public seasonsMeritAdminQuerySeasons(
    requestParameters?: SeasonsMeritAdminQuerySeasonsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfSeason>>;
  public seasonsMeritAdminQuerySeasons(
    requestParameters?: SeasonsMeritAdminQuerySeasonsParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/merit/seasons`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        Page: requestParameters?.page,
        Size: requestParameters?.size,
        'Sorting.OrderBy': requestParameters?.sortingOrderBy,
        'Sorting.Property': requestParameters?.sortingProperty,
        SeasonType: requestParameters?.seasonType,
        SimulationState: requestParameters?.simulationState,
        'Query.ManagerEndDateAt': requestParameters?.queryManagerEndDateAt,
        'Query.PartnerEndDateAt': requestParameters?.queryPartnerEndDateAt,
        'Query.SeasonType': requestParameters?.querySeasonType,
        'Query.SimulationState': requestParameters?.querySimulationState
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsMeritAdminQuerySimulation(
    requestParameters?: SeasonsMeritAdminQuerySimulationParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Array<PositionEvaluationSimulationModel>>;
  public seasonsMeritAdminQuerySimulation(
    requestParameters?: SeasonsMeritAdminQuerySimulationParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Array<PositionEvaluationSimulationModel>>>;
  public seasonsMeritAdminQuerySimulation(
    requestParameters?: SeasonsMeritAdminQuerySimulationParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Array<PositionEvaluationSimulationModel>>>;
  public seasonsMeritAdminQuerySimulation(
    requestParameters?: SeasonsMeritAdminQuerySimulationParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('seasonsMeritAdminQuerySimulation', { seasonId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/admin/api/v1/merit/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/simulations`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsMeritAdminRecalculateCandidatePools(
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfCandidatePoolRecalculationMetadata>;
  public seasonsMeritAdminRecalculateCandidatePools(
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfCandidatePoolRecalculationMetadata>>;
  public seasonsMeritAdminRecalculateCandidatePools(
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfCandidatePoolRecalculationMetadata>>;
  public seasonsMeritAdminRecalculateCandidatePools(...args: RequestArgs): Observable<any> {
    return this.sendRequest(args, {
      method: 'put',
      path: `/admin/api/v1/merit/candidate-pools/recalculate`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsMeritAdminRecalculateParentSettingsPopulationSimulationPopulations(
    requestParameters?: SeasonsMeritAdminRecalculateParentSettingsPopulationSimulationPopulationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfSettingsPopulationRecalculationMetadata>;
  public seasonsMeritAdminRecalculateParentSettingsPopulationSimulationPopulations(
    requestParameters?: SeasonsMeritAdminRecalculateParentSettingsPopulationSimulationPopulationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfSettingsPopulationRecalculationMetadata>>;
  public seasonsMeritAdminRecalculateParentSettingsPopulationSimulationPopulations(
    requestParameters?: SeasonsMeritAdminRecalculateParentSettingsPopulationSimulationPopulationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfSettingsPopulationRecalculationMetadata>>;
  public seasonsMeritAdminRecalculateParentSettingsPopulationSimulationPopulations(
    requestParameters?: SeasonsMeritAdminRecalculateParentSettingsPopulationSimulationPopulationsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    const parentSettingId = requestParameters?.parentSettingId;
    this.checkRequired('seasonsMeritAdminRecalculateParentSettingsPopulationSimulationPopulations', {
      simulationId,
      parentSettingId
    });
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v1/merit/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/population-recalculation/${this.configuration.encodeParam({ name: 'parentSettingId', value: parentSettingId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { settingsType: requestParameters?.settingsType }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsMeritAdminRecalculatePlanPopulations(
    requestParameters?: SeasonsMeritAdminRecalculatePlanPopulationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfPlanPopulationRecalculationMetadata>;
  public seasonsMeritAdminRecalculatePlanPopulations(
    requestParameters?: SeasonsMeritAdminRecalculatePlanPopulationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfPlanPopulationRecalculationMetadata>>;
  public seasonsMeritAdminRecalculatePlanPopulations(
    requestParameters?: SeasonsMeritAdminRecalculatePlanPopulationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfPlanPopulationRecalculationMetadata>>;
  public seasonsMeritAdminRecalculatePlanPopulations(
    requestParameters?: SeasonsMeritAdminRecalculatePlanPopulationsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('seasonsMeritAdminRecalculatePlanPopulations', { seasonId });
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v1/merit/plans/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/population-recalculation`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsMeritAdminRecalculateSettingsPopulationSimulationPopulations(
    requestParameters?: SeasonsMeritAdminRecalculateSettingsPopulationSimulationPopulationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfSettingsPopulationRecalculationMetadata>;
  public seasonsMeritAdminRecalculateSettingsPopulationSimulationPopulations(
    requestParameters?: SeasonsMeritAdminRecalculateSettingsPopulationSimulationPopulationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfSettingsPopulationRecalculationMetadata>>;
  public seasonsMeritAdminRecalculateSettingsPopulationSimulationPopulations(
    requestParameters?: SeasonsMeritAdminRecalculateSettingsPopulationSimulationPopulationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfSettingsPopulationRecalculationMetadata>>;
  public seasonsMeritAdminRecalculateSettingsPopulationSimulationPopulations(
    requestParameters?: SeasonsMeritAdminRecalculateSettingsPopulationSimulationPopulationsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    this.checkRequired('seasonsMeritAdminRecalculateSettingsPopulationSimulationPopulations', { simulationId });
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v1/merit/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/population-recalculation`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { settingsType: requestParameters?.settingsType }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsMeritAdminSavePlanPopulations(
    requestParameters?: SeasonsMeritAdminSavePlanPopulationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfPlanPopulationCreationMetadata>;
  public seasonsMeritAdminSavePlanPopulations(
    requestParameters?: SeasonsMeritAdminSavePlanPopulationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfPlanPopulationCreationMetadata>>;
  public seasonsMeritAdminSavePlanPopulations(
    requestParameters?: SeasonsMeritAdminSavePlanPopulationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfPlanPopulationCreationMetadata>>;
  public seasonsMeritAdminSavePlanPopulations(
    requestParameters?: SeasonsMeritAdminSavePlanPopulationsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('seasonsMeritAdminSavePlanPopulations', { id });
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v1/merit/plans/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/save-population`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsMeritAdminSaveSeasonPopulations(
    requestParameters?: SeasonsMeritAdminSaveSeasonPopulationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfPopulationCreationMetadata>;
  public seasonsMeritAdminSaveSeasonPopulations(
    requestParameters?: SeasonsMeritAdminSaveSeasonPopulationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfPopulationCreationMetadata>>;
  public seasonsMeritAdminSaveSeasonPopulations(
    requestParameters?: SeasonsMeritAdminSaveSeasonPopulationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfPopulationCreationMetadata>>;
  public seasonsMeritAdminSaveSeasonPopulations(
    requestParameters?: SeasonsMeritAdminSaveSeasonPopulationsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('seasonsMeritAdminSaveSeasonPopulations', { seasonId });
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v1/merit/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/save-population`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsMeritAdminSimulateEquitySettingsPopulationSimulationPopulations(
    requestParameters?: SeasonsMeritAdminSimulateEquitySettingsPopulationSimulationPopulationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<SimulationPopulationCreated>;
  public seasonsMeritAdminSimulateEquitySettingsPopulationSimulationPopulations(
    requestParameters?: SeasonsMeritAdminSimulateEquitySettingsPopulationSimulationPopulationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<SimulationPopulationCreated>>;
  public seasonsMeritAdminSimulateEquitySettingsPopulationSimulationPopulations(
    requestParameters?: SeasonsMeritAdminSimulateEquitySettingsPopulationSimulationPopulationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<SimulationPopulationCreated>>;
  public seasonsMeritAdminSimulateEquitySettingsPopulationSimulationPopulations(
    requestParameters?: SeasonsMeritAdminSimulateEquitySettingsPopulationSimulationPopulationsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    const settingsId = requestParameters?.settingsId;
    const simulationId = requestParameters?.simulationId;
    this.checkRequired('seasonsMeritAdminSimulateEquitySettingsPopulationSimulationPopulations', {
      seasonId,
      settingsId,
      simulationId
    });
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v1/merit/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/equity-settings/${this.configuration.encodeParam({ name: 'settingsId', value: settingsId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/simulate-population`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { Page: requestParameters?.page, Size: requestParameters?.size },
      body: requestParameters?.ruleSet,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsMeritAdminSimulateEquitySubSettingsPopulationSimulationPopulations(
    requestParameters?: SeasonsMeritAdminSimulateEquitySubSettingsPopulationSimulationPopulationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<SimulationPopulationCreated>;
  public seasonsMeritAdminSimulateEquitySubSettingsPopulationSimulationPopulations(
    requestParameters?: SeasonsMeritAdminSimulateEquitySubSettingsPopulationSimulationPopulationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<SimulationPopulationCreated>>;
  public seasonsMeritAdminSimulateEquitySubSettingsPopulationSimulationPopulations(
    requestParameters?: SeasonsMeritAdminSimulateEquitySubSettingsPopulationSimulationPopulationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<SimulationPopulationCreated>>;
  public seasonsMeritAdminSimulateEquitySubSettingsPopulationSimulationPopulations(
    requestParameters?: SeasonsMeritAdminSimulateEquitySubSettingsPopulationSimulationPopulationsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    const settingsId = requestParameters?.settingsId;
    const subSettingsId = requestParameters?.subSettingsId;
    const simulationId = requestParameters?.simulationId;
    this.checkRequired('seasonsMeritAdminSimulateEquitySubSettingsPopulationSimulationPopulations', {
      seasonId,
      settingsId,
      subSettingsId,
      simulationId
    });
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v1/merit/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/equity-settings/${this.configuration.encodeParam({ name: 'settingsId', value: settingsId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/equity-sub-settings/${this.configuration.encodeParam({ name: 'subSettingsId', value: subSettingsId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/simulate-population`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { Page: requestParameters?.page, Size: requestParameters?.size },
      body: requestParameters?.ruleSet,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsMeritAdminSimulateMeritPopulationSimulationPopulations(
    requestParameters?: SeasonsMeritAdminSimulateMeritPopulationSimulationPopulationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<SimulationPopulationCreated>;
  public seasonsMeritAdminSimulateMeritPopulationSimulationPopulations(
    requestParameters?: SeasonsMeritAdminSimulateMeritPopulationSimulationPopulationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<SimulationPopulationCreated>>;
  public seasonsMeritAdminSimulateMeritPopulationSimulationPopulations(
    requestParameters?: SeasonsMeritAdminSimulateMeritPopulationSimulationPopulationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<SimulationPopulationCreated>>;
  public seasonsMeritAdminSimulateMeritPopulationSimulationPopulations(
    requestParameters?: SeasonsMeritAdminSimulateMeritPopulationSimulationPopulationsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    const settingsId = requestParameters?.settingsId;
    const simulationId = requestParameters?.simulationId;
    this.checkRequired('seasonsMeritAdminSimulateMeritPopulationSimulationPopulations', {
      seasonId,
      settingsId,
      simulationId
    });
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v1/merit/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/merit-settings/${this.configuration.encodeParam({ name: 'settingsId', value: settingsId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/simulate-population`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { Page: requestParameters?.page, Size: requestParameters?.size },
      body: requestParameters?.ruleSet,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsMeritAdminSimulatePlanPopulations(
    requestParameters?: SeasonsMeritAdminSimulatePlanPopulationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PopulationCreatedResultPagedDto>;
  public seasonsMeritAdminSimulatePlanPopulations(
    requestParameters?: SeasonsMeritAdminSimulatePlanPopulationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PopulationCreatedResultPagedDto>>;
  public seasonsMeritAdminSimulatePlanPopulations(
    requestParameters?: SeasonsMeritAdminSimulatePlanPopulationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PopulationCreatedResultPagedDto>>;
  public seasonsMeritAdminSimulatePlanPopulations(
    requestParameters?: SeasonsMeritAdminSimulatePlanPopulationsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('seasonsMeritAdminSimulatePlanPopulations', { id });
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v1/merit/plans/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/simulate-population`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { Page: requestParameters?.page, Size: requestParameters?.size },
      body: requestParameters?.ruleSet,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsMeritAdminSimulateRuleInformationVisibilitySettings(
    requestParameters?: SeasonsMeritAdminSimulateRuleInformationVisibilitySettingsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfEmployeesEmployeesEmployee>;
  public seasonsMeritAdminSimulateRuleInformationVisibilitySettings(
    requestParameters?: SeasonsMeritAdminSimulateRuleInformationVisibilitySettingsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfEmployeesEmployeesEmployee>>;
  public seasonsMeritAdminSimulateRuleInformationVisibilitySettings(
    requestParameters?: SeasonsMeritAdminSimulateRuleInformationVisibilitySettingsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfEmployeesEmployeesEmployee>>;
  public seasonsMeritAdminSimulateRuleInformationVisibilitySettings(
    requestParameters?: SeasonsMeritAdminSimulateRuleInformationVisibilitySettingsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const settingsId = requestParameters?.settingsId;
    const simulationId = requestParameters?.simulationId;
    this.checkRequired('seasonsMeritAdminSimulateRuleInformationVisibilitySettings', { settingsId, simulationId });
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v1/merit/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/settings/information-visibility/${this.configuration.encodeParam({ name: 'settingsId', value: settingsId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/simulate-population`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { Page: requestParameters?.page, Size: requestParameters?.size },
      body: requestParameters?.ruleSet,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsMeritAdminSimulateSeasonPopulations(
    requestParameters?: SeasonsMeritAdminSimulateSeasonPopulationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<EmployeePopulationCreatedResultPagedDto>;
  public seasonsMeritAdminSimulateSeasonPopulations(
    requestParameters?: SeasonsMeritAdminSimulateSeasonPopulationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<EmployeePopulationCreatedResultPagedDto>>;
  public seasonsMeritAdminSimulateSeasonPopulations(
    requestParameters?: SeasonsMeritAdminSimulateSeasonPopulationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<EmployeePopulationCreatedResultPagedDto>>;
  public seasonsMeritAdminSimulateSeasonPopulations(
    requestParameters?: SeasonsMeritAdminSimulateSeasonPopulationsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('seasonsMeritAdminSimulateSeasonPopulations', { seasonId });
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v1/merit/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/simulate-population`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { Page: requestParameters?.page, Size: requestParameters?.size, export: requestParameters?._export },
      body: requestParameters?.ruleSet,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsMeritAdminUnPrePublishSimulationPublications(
    requestParameters?: SeasonsMeritAdminUnPrePublishSimulationPublicationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfSimulationPublishMetadata>;
  public seasonsMeritAdminUnPrePublishSimulationPublications(
    requestParameters?: SeasonsMeritAdminUnPrePublishSimulationPublicationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfSimulationPublishMetadata>>;
  public seasonsMeritAdminUnPrePublishSimulationPublications(
    requestParameters?: SeasonsMeritAdminUnPrePublishSimulationPublicationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfSimulationPublishMetadata>>;
  public seasonsMeritAdminUnPrePublishSimulationPublications(
    requestParameters?: SeasonsMeritAdminUnPrePublishSimulationPublicationsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    this.checkRequired('seasonsMeritAdminUnPrePublishSimulationPublications', { simulationId });
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v1/merit/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/un-pre-publish`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsMeritAdminUnPublishSimulationPublications(
    requestParameters?: SeasonsMeritAdminUnPublishSimulationPublicationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfSimulationPublishMetadata>;
  public seasonsMeritAdminUnPublishSimulationPublications(
    requestParameters?: SeasonsMeritAdminUnPublishSimulationPublicationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfSimulationPublishMetadata>>;
  public seasonsMeritAdminUnPublishSimulationPublications(
    requestParameters?: SeasonsMeritAdminUnPublishSimulationPublicationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfSimulationPublishMetadata>>;
  public seasonsMeritAdminUnPublishSimulationPublications(
    requestParameters?: SeasonsMeritAdminUnPublishSimulationPublicationsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    this.checkRequired('seasonsMeritAdminUnPublishSimulationPublications', { simulationId });
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v1/merit/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/un-publish`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        'Query.PositionName': requestParameters?.queryPositionName,
        'Query.OrgCode': requestParameters?.queryOrgCode,
        'Query.OrgCodeStartsWith': requestParameters?.queryOrgCodeStartsWith,
        'Query.OrgLevel': requestParameters?.queryOrgLevel,
        'Query.OrgSize': requestParameters?.queryOrgSize,
        'Query.MercerJobCode': requestParameters?.queryMercerJobCode,
        'Query.PositionClass': requestParameters?.queryPositionClass,
        'Query.NewPositionClass': requestParameters?.queryNewPositionClass,
        'Query.OriginalProposedPositionClass': requestParameters?.queryOriginalProposedPositionClass,
        'Query.PositionType': requestParameters?.queryPositionType,
        'Query.CountryIsoCode': requestParameters?.queryCountryIsoCode,
        'Query.IncumbentGid': requestParameters?.queryIncumbentGid,
        'Query.IncumbentFirstName': requestParameters?.queryIncumbentFirstName,
        'Query.IncumbentLastName': requestParameters?.queryIncumbentLastName,
        'Query.IncumbentCountryPlaceOfAction': requestParameters?.queryIncumbentCountryPlaceOfAction,
        'Query.ValidationManagerId': requestParameters?.queryValidationManagerId,
        'Query.ValidationManagerGid': requestParameters?.queryValidationManagerGid,
        'Query.ValidationManagerFirstName': requestParameters?.queryValidationManagerFirstName,
        'Query.ValidationManagerLastName': requestParameters?.queryValidationManagerLastName,
        'Query.ValidationState': requestParameters?.queryValidationState,
        'Query.PlacementState': requestParameters?.queryPlacementState,
        'Query.NewHireState': requestParameters?.queryNewHireState,
        'Query.IsLocked': requestParameters?.queryIsLocked,
        'Query.MercerJobFamily': requestParameters?.queryMercerJobFamily,
        'Query.MercerJobSpecialization': requestParameters?.queryMercerJobSpecialization,
        'Query.MercerJobSubFamily': requestParameters?.queryMercerJobSubFamily,
        'Query.IncumbentAre': requestParameters?.queryIncumbentAre,
        'Query.Tag': requestParameters?.queryTag,
        'Query.WasPromoted': requestParameters?.queryWasPromoted,
        'Query.IsTransferred': requestParameters?.queryIsTransferred
      },
      body: requestParameters?.unPublishSimulation,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsMeritAdminUpdateBenchmarkValuesSnapshots(
    requestParameters?: SeasonsMeritAdminUpdateBenchmarkValuesSnapshotsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfImportStatusMetadata>;
  public seasonsMeritAdminUpdateBenchmarkValuesSnapshots(
    requestParameters?: SeasonsMeritAdminUpdateBenchmarkValuesSnapshotsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfImportStatusMetadata>>;
  public seasonsMeritAdminUpdateBenchmarkValuesSnapshots(
    requestParameters?: SeasonsMeritAdminUpdateBenchmarkValuesSnapshotsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfImportStatusMetadata>>;
  public seasonsMeritAdminUpdateBenchmarkValuesSnapshots(
    requestParameters?: SeasonsMeritAdminUpdateBenchmarkValuesSnapshotsParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'patch',
      path: `/admin/api/v1/merit/snapshots/benchmarks`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.updateSnapshotBenchmarkValues,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsMeritAdminUpdateBucketComponentBatchBudgetComponents(
    requestParameters?: SeasonsMeritAdminUpdateBucketComponentBatchBudgetComponentsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<BucketComponentModificationResponse>;
  public seasonsMeritAdminUpdateBucketComponentBatchBudgetComponents(
    requestParameters?: SeasonsMeritAdminUpdateBucketComponentBatchBudgetComponentsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<BucketComponentModificationResponse>>;
  public seasonsMeritAdminUpdateBucketComponentBatchBudgetComponents(
    requestParameters?: SeasonsMeritAdminUpdateBucketComponentBatchBudgetComponentsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<BucketComponentModificationResponse>>;
  public seasonsMeritAdminUpdateBucketComponentBatchBudgetComponents(
    requestParameters?: SeasonsMeritAdminUpdateBucketComponentBatchBudgetComponentsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const budgetBucketId = requestParameters?.budgetBucketId;
    this.checkRequired('seasonsMeritAdminUpdateBucketComponentBatchBudgetComponents', { budgetBucketId });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/admin/api/v1/merit/budget-bucket/${this.configuration.encodeParam({ name: 'budgetBucketId', value: budgetBucketId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/budget-components/batch`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.updateManyBucketComponents,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsMeritAdminUpdateBucketComponentBudgetComponents(
    requestParameters?: SeasonsMeritAdminUpdateBucketComponentBudgetComponentsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<BucketComponentModificationResponse>;
  public seasonsMeritAdminUpdateBucketComponentBudgetComponents(
    requestParameters?: SeasonsMeritAdminUpdateBucketComponentBudgetComponentsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<BucketComponentModificationResponse>>;
  public seasonsMeritAdminUpdateBucketComponentBudgetComponents(
    requestParameters?: SeasonsMeritAdminUpdateBucketComponentBudgetComponentsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<BucketComponentModificationResponse>>;
  public seasonsMeritAdminUpdateBucketComponentBudgetComponents(
    requestParameters?: SeasonsMeritAdminUpdateBucketComponentBudgetComponentsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const budgetBucketId = requestParameters?.budgetBucketId;
    this.checkRequired('seasonsMeritAdminUpdateBucketComponentBudgetComponents', { budgetBucketId });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/admin/api/v1/merit/budget-bucket/${this.configuration.encodeParam({ name: 'budgetBucketId', value: budgetBucketId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/budget-components`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.updateBucketComponent,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsMeritAdminUpdateBudgetBuckets(
    requestParameters?: SeasonsMeritAdminUpdateBudgetBucketsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<BudgetBucketModificationResponse>;
  public seasonsMeritAdminUpdateBudgetBuckets(
    requestParameters?: SeasonsMeritAdminUpdateBudgetBucketsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<BudgetBucketModificationResponse>>;
  public seasonsMeritAdminUpdateBudgetBuckets(
    requestParameters?: SeasonsMeritAdminUpdateBudgetBucketsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<BudgetBucketModificationResponse>>;
  public seasonsMeritAdminUpdateBudgetBuckets(
    requestParameters?: SeasonsMeritAdminUpdateBudgetBucketsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('seasonsMeritAdminUpdateBudgetBuckets', { id });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/admin/api/v1/merit/budget-bucket/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.updateBudgetBucket,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsMeritAdminUpdateCandidatePools(
    requestParameters?: SeasonsMeritAdminUpdateCandidatePoolsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<CandidatePoolModel>;
  public seasonsMeritAdminUpdateCandidatePools(
    requestParameters?: SeasonsMeritAdminUpdateCandidatePoolsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<CandidatePoolModel>>;
  public seasonsMeritAdminUpdateCandidatePools(
    requestParameters?: SeasonsMeritAdminUpdateCandidatePoolsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<CandidatePoolModel>>;
  public seasonsMeritAdminUpdateCandidatePools(
    requestParameters?: SeasonsMeritAdminUpdateCandidatePoolsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('seasonsMeritAdminUpdateCandidatePools', { id });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/admin/api/v1/merit/candidate-pools/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.updateCandidatePool,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsMeritAdminUpdateEmployeeSnapshots(
    requestParameters?: SeasonsMeritAdminUpdateEmployeeSnapshotsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<EmployeeSnapshotsEmployeeSnapshot>;
  public seasonsMeritAdminUpdateEmployeeSnapshots(
    requestParameters?: SeasonsMeritAdminUpdateEmployeeSnapshotsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<EmployeeSnapshotsEmployeeSnapshot>>;
  public seasonsMeritAdminUpdateEmployeeSnapshots(
    requestParameters?: SeasonsMeritAdminUpdateEmployeeSnapshotsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<EmployeeSnapshotsEmployeeSnapshot>>;
  public seasonsMeritAdminUpdateEmployeeSnapshots(
    requestParameters?: SeasonsMeritAdminUpdateEmployeeSnapshotsParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'put',
      path: `/admin/api/v1/merit/employee-snapshots`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.updateEmployeeSnapshot,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsMeritAdminUpdateInformationVisibilitySettings(
    requestParameters?: SeasonsMeritAdminUpdateInformationVisibilitySettingsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<MeritInformationVisibilitySettingsModel>;
  public seasonsMeritAdminUpdateInformationVisibilitySettings(
    requestParameters?: SeasonsMeritAdminUpdateInformationVisibilitySettingsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<MeritInformationVisibilitySettingsModel>>;
  public seasonsMeritAdminUpdateInformationVisibilitySettings(
    requestParameters?: SeasonsMeritAdminUpdateInformationVisibilitySettingsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<MeritInformationVisibilitySettingsModel>>;
  public seasonsMeritAdminUpdateInformationVisibilitySettings(
    requestParameters?: SeasonsMeritAdminUpdateInformationVisibilitySettingsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const settingsId = requestParameters?.settingsId;
    const simulationId = requestParameters?.simulationId;
    this.checkRequired('seasonsMeritAdminUpdateInformationVisibilitySettings', { settingsId, simulationId });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/admin/api/v1/merit/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/settings/information-visibility/${this.configuration.encodeParam({ name: 'settingsId', value: settingsId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.updateInformationVisibilitySettings,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsMeritAdminUpdateManyBudgetBuckets(
    requestParameters?: SeasonsMeritAdminUpdateManyBudgetBucketsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<BudgetBucketModificationResponse>;
  public seasonsMeritAdminUpdateManyBudgetBuckets(
    requestParameters?: SeasonsMeritAdminUpdateManyBudgetBucketsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<BudgetBucketModificationResponse>>;
  public seasonsMeritAdminUpdateManyBudgetBuckets(
    requestParameters?: SeasonsMeritAdminUpdateManyBudgetBucketsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<BudgetBucketModificationResponse>>;
  public seasonsMeritAdminUpdateManyBudgetBuckets(
    requestParameters?: SeasonsMeritAdminUpdateManyBudgetBucketsParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'patch',
      path: `/admin/api/v1/merit/budget-bucket/batch`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.updateManyBudgetBuckets,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsMeritAdminUpdateMembers(
    requestParameters?: SeasonsMeritAdminUpdateMembersParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<MemberModel>;
  public seasonsMeritAdminUpdateMembers(
    requestParameters?: SeasonsMeritAdminUpdateMembersParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<MemberModel>>;
  public seasonsMeritAdminUpdateMembers(
    requestParameters?: SeasonsMeritAdminUpdateMembersParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<MemberModel>>;
  public seasonsMeritAdminUpdateMembers(
    requestParameters?: SeasonsMeritAdminUpdateMembersParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'put',
      path: `/admin/api/v1/merit/members`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.updateMember,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsMeritAdminUpdateOrganisationInformationSnapshots(
    requestParameters?: SeasonsMeritAdminUpdateOrganisationInformationSnapshotsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<OrganisationInformationSnapshotModel>;
  public seasonsMeritAdminUpdateOrganisationInformationSnapshots(
    requestParameters?: SeasonsMeritAdminUpdateOrganisationInformationSnapshotsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<OrganisationInformationSnapshotModel>>;
  public seasonsMeritAdminUpdateOrganisationInformationSnapshots(
    requestParameters?: SeasonsMeritAdminUpdateOrganisationInformationSnapshotsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<OrganisationInformationSnapshotModel>>;
  public seasonsMeritAdminUpdateOrganisationInformationSnapshots(
    requestParameters?: SeasonsMeritAdminUpdateOrganisationInformationSnapshotsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    const id = requestParameters?.id;
    this.checkRequired('seasonsMeritAdminUpdateOrganisationInformationSnapshots', { seasonId, id });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/admin/api/v1/merit/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/snapshots/organisations/information/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.updateOrganisationInformationSnapshot,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsMeritAdminUpdatePlanSettings(
    requestParameters?: SeasonsMeritAdminUpdatePlanSettingsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PlanSettingsModel>;
  public seasonsMeritAdminUpdatePlanSettings(
    requestParameters?: SeasonsMeritAdminUpdatePlanSettingsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PlanSettingsModel>>;
  public seasonsMeritAdminUpdatePlanSettings(
    requestParameters?: SeasonsMeritAdminUpdatePlanSettingsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PlanSettingsModel>>;
  public seasonsMeritAdminUpdatePlanSettings(
    requestParameters?: SeasonsMeritAdminUpdatePlanSettingsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    const planId = requestParameters?.planId;
    this.checkRequired('seasonsMeritAdminUpdatePlanSettings', { id, planId });
    return this.sendRequest(args, {
      method: 'put',
      path: `/admin/api/v1/merit/season-plans/${this.configuration.encodeParam({ name: 'planId', value: planId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/settings/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.updatePlanSettings,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsMeritAdminUpdatePlans(
    requestParameters?: SeasonsMeritAdminUpdatePlansParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PlanModel>;
  public seasonsMeritAdminUpdatePlans(
    requestParameters?: SeasonsMeritAdminUpdatePlansParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PlanModel>>;
  public seasonsMeritAdminUpdatePlans(
    requestParameters?: SeasonsMeritAdminUpdatePlansParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PlanModel>>;
  public seasonsMeritAdminUpdatePlans(
    requestParameters?: SeasonsMeritAdminUpdatePlansParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('seasonsMeritAdminUpdatePlans', { id });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/admin/api/v1/merit/plans/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.updatePlan,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsMeritAdminUpdatePublicationSettingsPublicationSettings(
    requestParameters?: SeasonsMeritAdminUpdatePublicationSettingsPublicationSettingsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PublicationSettingsModel>;
  public seasonsMeritAdminUpdatePublicationSettingsPublicationSettings(
    requestParameters?: SeasonsMeritAdminUpdatePublicationSettingsPublicationSettingsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PublicationSettingsModel>>;
  public seasonsMeritAdminUpdatePublicationSettingsPublicationSettings(
    requestParameters?: SeasonsMeritAdminUpdatePublicationSettingsPublicationSettingsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PublicationSettingsModel>>;
  public seasonsMeritAdminUpdatePublicationSettingsPublicationSettings(
    requestParameters?: SeasonsMeritAdminUpdatePublicationSettingsPublicationSettingsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('seasonsMeritAdminUpdatePublicationSettingsPublicationSettings', { seasonId });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/admin/api/v1/merit/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/publication-settings`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.updatePublicationSettings,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsMeritAdminUpdateSeasonCommunicationSettings(
    requestParameters?: SeasonsMeritAdminUpdateSeasonCommunicationSettingsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<MeritCommunicationSettings>;
  public seasonsMeritAdminUpdateSeasonCommunicationSettings(
    requestParameters?: SeasonsMeritAdminUpdateSeasonCommunicationSettingsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<MeritCommunicationSettings>>;
  public seasonsMeritAdminUpdateSeasonCommunicationSettings(
    requestParameters?: SeasonsMeritAdminUpdateSeasonCommunicationSettingsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<MeritCommunicationSettings>>;
  public seasonsMeritAdminUpdateSeasonCommunicationSettings(
    requestParameters?: SeasonsMeritAdminUpdateSeasonCommunicationSettingsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('seasonsMeritAdminUpdateSeasonCommunicationSettings', { seasonId });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/admin/api/v1/merit/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/communication-settings`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.updateCommunicationSettings,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsMeritAdminUpdateSeasonSettings(
    requestParameters?: SeasonsMeritAdminUpdateSeasonSettingsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<SeasonSettingsModel>;
  public seasonsMeritAdminUpdateSeasonSettings(
    requestParameters?: SeasonsMeritAdminUpdateSeasonSettingsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<SeasonSettingsModel>>;
  public seasonsMeritAdminUpdateSeasonSettings(
    requestParameters?: SeasonsMeritAdminUpdateSeasonSettingsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<SeasonSettingsModel>>;
  public seasonsMeritAdminUpdateSeasonSettings(
    requestParameters?: SeasonsMeritAdminUpdateSeasonSettingsParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'put',
      path: `/admin/api/v1/merit/settings`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.setSeasonSettings,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsMeritAdminUpdateSeasons(
    requestParameters?: SeasonsMeritAdminUpdateSeasonsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<SeasonModel>;
  public seasonsMeritAdminUpdateSeasons(
    requestParameters?: SeasonsMeritAdminUpdateSeasonsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<SeasonModel>>;
  public seasonsMeritAdminUpdateSeasons(
    requestParameters?: SeasonsMeritAdminUpdateSeasonsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<SeasonModel>>;
  public seasonsMeritAdminUpdateSeasons(
    requestParameters?: SeasonsMeritAdminUpdateSeasonsParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'put',
      path: `/admin/api/v1/merit/seasons`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.updateSeason,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsMeritAdminUpdateSimulation(
    requestParameters?: SeasonsMeritAdminUpdateSimulationParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<SeasonsSimulationsSimulation>;
  public seasonsMeritAdminUpdateSimulation(
    requestParameters?: SeasonsMeritAdminUpdateSimulationParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<SeasonsSimulationsSimulation>>;
  public seasonsMeritAdminUpdateSimulation(
    requestParameters?: SeasonsMeritAdminUpdateSimulationParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<SeasonsSimulationsSimulation>>;
  public seasonsMeritAdminUpdateSimulation(
    requestParameters?: SeasonsMeritAdminUpdateSimulationParams,
    ...args: RequestArgs
  ): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    this.checkRequired('seasonsMeritAdminUpdateSimulation', { simulationId });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/admin/api/v1/merit/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.seasonsSimulationsUpdateSimulation,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsMeritAdminUpdateSimulationMembersSimulation(
    requestParameters?: SeasonsMeritAdminUpdateSimulationMembersSimulationParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfIMetadata>;
  public seasonsMeritAdminUpdateSimulationMembersSimulation(
    requestParameters?: SeasonsMeritAdminUpdateSimulationMembersSimulationParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfIMetadata>>;
  public seasonsMeritAdminUpdateSimulationMembersSimulation(
    requestParameters?: SeasonsMeritAdminUpdateSimulationMembersSimulationParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfIMetadata>>;
  public seasonsMeritAdminUpdateSimulationMembersSimulation(
    requestParameters?: SeasonsMeritAdminUpdateSimulationMembersSimulationParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    const simulationId = requestParameters?.simulationId;
    this.checkRequired('seasonsMeritAdminUpdateSimulationMembersSimulation', { seasonId, simulationId });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/admin/api/v1/merit/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/update-members`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.updateSimulationMembers,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public simulateMeritIncentiveSettingsPopulationSimulationPopulations(
    requestParameters?: SimulateMeritIncentiveSettingsPopulationSimulationPopulationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<SimulationPopulationCreated>;
  public simulateMeritIncentiveSettingsPopulationSimulationPopulations(
    requestParameters?: SimulateMeritIncentiveSettingsPopulationSimulationPopulationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<SimulationPopulationCreated>>;
  public simulateMeritIncentiveSettingsPopulationSimulationPopulations(
    requestParameters?: SimulateMeritIncentiveSettingsPopulationSimulationPopulationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<SimulationPopulationCreated>>;
  public simulateMeritIncentiveSettingsPopulationSimulationPopulations(
    requestParameters?: SimulateMeritIncentiveSettingsPopulationSimulationPopulationsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    const settingsId = requestParameters?.settingsId;
    const simulationId = requestParameters?.simulationId;
    this.checkRequired('simulateMeritIncentiveSettingsPopulationSimulationPopulations', {
      seasonId,
      settingsId,
      simulationId
    });
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v1/merit/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/incentive-settings/${this.configuration.encodeParam({ name: 'settingsId', value: settingsId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/simulate-population`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { Page: requestParameters?.page, Size: requestParameters?.size },
      body: requestParameters?.ruleSet,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public simulateMeritincentiveSubSettingsPopulationSimulationPopulations(
    requestParameters?: SimulateMeritincentiveSubSettingsPopulationSimulationPopulationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<SimulationPopulationCreated>;
  public simulateMeritincentiveSubSettingsPopulationSimulationPopulations(
    requestParameters?: SimulateMeritincentiveSubSettingsPopulationSimulationPopulationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<SimulationPopulationCreated>>;
  public simulateMeritincentiveSubSettingsPopulationSimulationPopulations(
    requestParameters?: SimulateMeritincentiveSubSettingsPopulationSimulationPopulationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<SimulationPopulationCreated>>;
  public simulateMeritincentiveSubSettingsPopulationSimulationPopulations(
    requestParameters?: SimulateMeritincentiveSubSettingsPopulationSimulationPopulationsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    const settingsId = requestParameters?.settingsId;
    const subSettingsId = requestParameters?.subSettingsId;
    const simulationId = requestParameters?.simulationId;
    this.checkRequired('simulateMeritincentiveSubSettingsPopulationSimulationPopulations', {
      seasonId,
      settingsId,
      subSettingsId,
      simulationId
    });
    return this.sendRequest(args, {
      method: 'post',
      path: `/admin/api/v1/merit/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/incentive-settings/${this.configuration.encodeParam({ name: 'settingsId', value: settingsId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/incentive-sub-settings/${this.configuration.encodeParam({ name: 'subSettingsId', value: subSettingsId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/simulate-population`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { Page: requestParameters?.page, Size: requestParameters?.size },
      body: requestParameters?.ruleSet,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }
}
